/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as IndexImport } from './routes/index'
import { Route as UIndexImport } from './routes/u/index'
import { Route as StaffResetPasswordImport } from './routes/staff/reset-password'
import { Route as StaffLoginImport } from './routes/staff/login'
import { Route as StaffInvitationImport } from './routes/staff/invitation'
import { Route as MerchantResetPasswordImport } from './routes/merchant/reset-password'
import { Route as MerchantLoginImport } from './routes/merchant/login'
import { Route as MerchantInvitationImport } from './routes/merchant/invitation'
import { Route as AcquirerResetPasswordImport } from './routes/acquirer/reset-password'
import { Route as AcquirerLoginImport } from './routes/acquirer/login'
import { Route as AcquirerInvitationImport } from './routes/acquirer/invitation'
import { Route as ULocalIdIndexImport } from './routes/u/$localId/index'
import { Route as ULocalIdStaffImport } from './routes/u/$localId/_staff'
import { Route as ULocalIdMerchantImport } from './routes/u/$localId/_merchant'
import { Route as ULocalIdAcquirerImport } from './routes/u/$localId/_acquirer'
import { Route as ULocalIdStaffStaffIndexImport } from './routes/u/$localId/_staff.staff/index'
import { Route as ULocalIdMerchantMerchantIndexImport } from './routes/u/$localId/_merchant.merchant/index'
import { Route as ULocalIdAcquirerAcquirerIndexImport } from './routes/u/$localId/_acquirer.acquirer/index'
import { Route as ULocalIdStaffStaffUsersIndexImport } from './routes/u/$localId/_staff.staff/users/index'
import { Route as ULocalIdStaffStaffTransactionsIndexImport } from './routes/u/$localId/_staff.staff/transactions/index'
import { Route as ULocalIdStaffStaffTdsMerchantsIndexImport } from './routes/u/$localId/_staff.staff/tds-merchants/index'
import { Route as ULocalIdStaffStaffSettingsIndexImport } from './routes/u/$localId/_staff.staff/settings/index'
import { Route as ULocalIdStaffStaffOrdersIndexImport } from './routes/u/$localId/_staff.staff/orders/index'
import { Route as ULocalIdStaffStaffMerchantsIndexImport } from './routes/u/$localId/_staff.staff/merchants/index'
import { Route as ULocalIdStaffStaffCardAuthenticationsIndexImport } from './routes/u/$localId/_staff.staff/card-authentications/index'
import { Route as ULocalIdStaffStaffBenchUsersIndexImport } from './routes/u/$localId/_staff.staff/bench-users/index'
import { Route as ULocalIdStaffStaffAuditLogsIndexImport } from './routes/u/$localId/_staff.staff/audit-logs/index'
import { Route as ULocalIdStaffStaffAgreementsIndexImport } from './routes/u/$localId/_staff.staff/agreements/index'
import { Route as ULocalIdStaffStaffAcquirersIndexImport } from './routes/u/$localId/_staff.staff/acquirers/index'
import { Route as ULocalIdMerchantMerchantUsersIndexImport } from './routes/u/$localId/_merchant.merchant/users/index'
import { Route as ULocalIdMerchantMerchantTransactionsIndexImport } from './routes/u/$localId/_merchant.merchant/transactions/index'
import { Route as ULocalIdMerchantMerchantSettingsIndexImport } from './routes/u/$localId/_merchant.merchant/settings/index'
import { Route as ULocalIdMerchantMerchantPaymentControlsIndexImport } from './routes/u/$localId/_merchant.merchant/payment-controls/index'
import { Route as ULocalIdMerchantMerchantOrdersIndexImport } from './routes/u/$localId/_merchant.merchant/orders/index'
import { Route as ULocalIdMerchantMerchantLinksIndexImport } from './routes/u/$localId/_merchant.merchant/links/index'
import { Route as ULocalIdMerchantMerchantCardAuthenticationsIndexImport } from './routes/u/$localId/_merchant.merchant/card-authentications/index'
import { Route as ULocalIdMerchantMerchantAuditLogsIndexImport } from './routes/u/$localId/_merchant.merchant/audit-logs/index'
import { Route as ULocalIdMerchantMerchantApiKeysIndexImport } from './routes/u/$localId/_merchant.merchant/api-keys/index'
import { Route as ULocalIdMerchantMerchantAgreementsIndexImport } from './routes/u/$localId/_merchant.merchant/agreements/index'
import { Route as ULocalIdAcquirerAcquirerUsersIndexImport } from './routes/u/$localId/_acquirer.acquirer/users/index'
import { Route as ULocalIdAcquirerAcquirerTransactionsIndexImport } from './routes/u/$localId/_acquirer.acquirer/transactions/index'
import { Route as ULocalIdAcquirerAcquirerSettingsIndexImport } from './routes/u/$localId/_acquirer.acquirer/settings/index'
import { Route as ULocalIdAcquirerAcquirerPaymentControlsIndexImport } from './routes/u/$localId/_acquirer.acquirer/payment-controls/index'
import { Route as ULocalIdAcquirerAcquirerOrdersIndexImport } from './routes/u/$localId/_acquirer.acquirer/orders/index'
import { Route as ULocalIdAcquirerAcquirerMerchantsIndexImport } from './routes/u/$localId/_acquirer.acquirer/merchants/index'
import { Route as ULocalIdAcquirerAcquirerLinksIndexImport } from './routes/u/$localId/_acquirer.acquirer/links/index'
import { Route as ULocalIdAcquirerAcquirerEodStatementsIndexImport } from './routes/u/$localId/_acquirer.acquirer/eod-statements/index'
import { Route as ULocalIdAcquirerAcquirerCardAuthenticationsIndexImport } from './routes/u/$localId/_acquirer.acquirer/card-authentications/index'
import { Route as ULocalIdAcquirerAcquirerAuditLogsIndexImport } from './routes/u/$localId/_acquirer.acquirer/audit-logs/index'
import { Route as ULocalIdAcquirerAcquirerApiKeysIndexImport } from './routes/u/$localId/_acquirer.acquirer/api-keys/index'
import { Route as ULocalIdAcquirerAcquirerAgreementsIndexImport } from './routes/u/$localId/_acquirer.acquirer/agreements/index'
import { Route as ULocalIdStaffStaffUsersNewImport } from './routes/u/$localId/_staff.staff/users/new'
import { Route as ULocalIdStaffStaffTdsMerchantsIdImport } from './routes/u/$localId/_staff.staff/tds-merchants/$id'
import { Route as ULocalIdStaffStaffOrdersIdImport } from './routes/u/$localId/_staff.staff/orders/$id'
import { Route as ULocalIdStaffStaffMerchantsMerchantIdImport } from './routes/u/$localId/_staff.staff/merchants/$merchantId'
import { Route as ULocalIdStaffStaffCardAuthenticationsIdImport } from './routes/u/$localId/_staff.staff/card-authentications/$id'
import { Route as ULocalIdStaffStaffBinsImportImport } from './routes/u/$localId/_staff.staff/bins/import'
import { Route as ULocalIdStaffStaffBenchUsersNewImport } from './routes/u/$localId/_staff.staff/bench-users/new'
import { Route as ULocalIdStaffStaffAuditLogsIdImport } from './routes/u/$localId/_staff.staff/audit-logs/$id'
import { Route as ULocalIdStaffStaffAgreementsIdImport } from './routes/u/$localId/_staff.staff/agreements/$id'
import { Route as ULocalIdStaffStaffAcquirersNewImport } from './routes/u/$localId/_staff.staff/acquirers/new'
import { Route as ULocalIdStaffStaffAcquirersAcquirerIdImport } from './routes/u/$localId/_staff.staff/acquirers/$acquirerId'
import { Route as ULocalIdMerchantMerchantUsersNewImport } from './routes/u/$localId/_merchant.merchant/users/new'
import { Route as ULocalIdMerchantMerchantOrdersIdImport } from './routes/u/$localId/_merchant.merchant/orders/$id'
import { Route as ULocalIdMerchantMerchantLinksIdImport } from './routes/u/$localId/_merchant.merchant/links/$id'
import { Route as ULocalIdMerchantMerchantCardAuthenticationsIdImport } from './routes/u/$localId/_merchant.merchant/card-authentications/$id'
import { Route as ULocalIdMerchantMerchantAuditLogsIdImport } from './routes/u/$localId/_merchant.merchant/audit-logs/$id'
import { Route as ULocalIdMerchantMerchantApiKeysNewImport } from './routes/u/$localId/_merchant.merchant/api-keys/new'
import { Route as ULocalIdMerchantMerchantAgreementsIdImport } from './routes/u/$localId/_merchant.merchant/agreements/$id'
import { Route as ULocalIdAcquirerAcquirerUsersNewImport } from './routes/u/$localId/_acquirer.acquirer/users/new'
import { Route as ULocalIdAcquirerAcquirerOrdersIdImport } from './routes/u/$localId/_acquirer.acquirer/orders/$id'
import { Route as ULocalIdAcquirerAcquirerMerchantsNewImport } from './routes/u/$localId/_acquirer.acquirer/merchants/new'
import { Route as ULocalIdAcquirerAcquirerMerchantsMerchantIdImport } from './routes/u/$localId/_acquirer.acquirer/merchants/$merchantId'
import { Route as ULocalIdAcquirerAcquirerLinksIdImport } from './routes/u/$localId/_acquirer.acquirer/links/$id'
import { Route as ULocalIdAcquirerAcquirerCardAuthenticationsIdImport } from './routes/u/$localId/_acquirer.acquirer/card-authentications/$id'
import { Route as ULocalIdAcquirerAcquirerAuditLogsIdImport } from './routes/u/$localId/_acquirer.acquirer/audit-logs/$id'
import { Route as ULocalIdAcquirerAcquirerApiKeysNewImport } from './routes/u/$localId/_acquirer.acquirer/api-keys/new'
import { Route as ULocalIdAcquirerAcquirerAgreementsIdImport } from './routes/u/$localId/_acquirer.acquirer/agreements/$id'
import { Route as ULocalIdStaffStaffUsersIdIndexImport } from './routes/u/$localId/_staff.staff/users/$id/index'
import { Route as ULocalIdMerchantMerchantUsersIdIndexImport } from './routes/u/$localId/_merchant.merchant/users/$id/index'
import { Route as ULocalIdMerchantMerchantPaymentControlsTypeIndexImport } from './routes/u/$localId/_merchant.merchant/payment-controls/$type/index'
import { Route as ULocalIdMerchantMerchantApiKeysIdIndexImport } from './routes/u/$localId/_merchant.merchant/api-keys/$id/index'
import { Route as ULocalIdAcquirerAcquirerUsersIdIndexImport } from './routes/u/$localId/_acquirer.acquirer/users/$id/index'
import { Route as ULocalIdAcquirerAcquirerPaymentControlsTypeIndexImport } from './routes/u/$localId/_acquirer.acquirer/payment-controls/$type/index'
import { Route as ULocalIdAcquirerAcquirerApiKeysIdIndexImport } from './routes/u/$localId/_acquirer.acquirer/api-keys/$id/index'
import { Route as ULocalIdStaffStaffUsersIdEditImport } from './routes/u/$localId/_staff.staff/users/$id/edit'
import { Route as ULocalIdStaffStaffOrdersIdTransactionsImport } from './routes/u/$localId/_staff.staff/orders/$id/transactions'
import { Route as ULocalIdStaffStaffOrdersIdSubMerchantImport } from './routes/u/$localId/_staff.staff/orders/$id/subMerchant'
import { Route as ULocalIdStaffStaffOrdersIdSourceImport } from './routes/u/$localId/_staff.staff/orders/$id/source'
import { Route as ULocalIdStaffStaffOrdersIdMerchantImport } from './routes/u/$localId/_staff.staff/orders/$id/merchant'
import { Route as ULocalIdStaffStaffOrdersIdApiResponseImport } from './routes/u/$localId/_staff.staff/orders/$id/apiResponse'
import { Route as ULocalIdStaffStaffOrdersIdAgreementImport } from './routes/u/$localId/_staff.staff/orders/$id/agreement'
import { Route as ULocalIdStaffStaffMerchantsMerchantIdEditImport } from './routes/u/$localId/_staff.staff/merchants/$merchantId_/edit'
import { Route as ULocalIdStaffStaffMerchantsMerchantIdUsersImport } from './routes/u/$localId/_staff.staff/merchants/$merchantId/users'
import { Route as ULocalIdStaffStaffMerchantsMerchantIdTransactionsImport } from './routes/u/$localId/_staff.staff/merchants/$merchantId/transactions'
import { Route as ULocalIdStaffStaffMerchantsMerchantIdOrdersImport } from './routes/u/$localId/_staff.staff/merchants/$merchantId/orders'
import { Route as ULocalIdStaffStaffMerchantsMerchantIdLinksImport } from './routes/u/$localId/_staff.staff/merchants/$merchantId/links'
import { Route as ULocalIdStaffStaffMerchantsMerchantIdApiKeysImport } from './routes/u/$localId/_staff.staff/merchants/$merchantId/api-keys'
import { Route as ULocalIdStaffStaffCardAuthenticationsIdMerchantImport } from './routes/u/$localId/_staff.staff/card-authentications/$id/merchant'
import { Route as ULocalIdStaffStaffCardAuthenticationsIdAuthImport } from './routes/u/$localId/_staff.staff/card-authentications/$id/auth'
import { Route as ULocalIdStaffStaffCardAuthenticationsIdApiResponseImport } from './routes/u/$localId/_staff.staff/card-authentications/$id/apiResponse'
import { Route as ULocalIdStaffStaffBenchUsersIdEditImport } from './routes/u/$localId/_staff.staff/bench-users/$id/edit'
import { Route as ULocalIdStaffStaffAgreementsIdOrdersImport } from './routes/u/$localId/_staff.staff/agreements/$id/orders'
import { Route as ULocalIdStaffStaffAgreementsIdApiResponseImport } from './routes/u/$localId/_staff.staff/agreements/$id/api-response'
import { Route as ULocalIdStaffStaffAcquirersAcquirerIdEditImport } from './routes/u/$localId/_staff.staff/acquirers/$acquirerId_/edit'
import { Route as ULocalIdStaffStaffAcquirersAcquirerIdUsersImport } from './routes/u/$localId/_staff.staff/acquirers/$acquirerId/users'
import { Route as ULocalIdStaffStaffAcquirersAcquirerIdTransactionsImport } from './routes/u/$localId/_staff.staff/acquirers/$acquirerId/transactions'
import { Route as ULocalIdStaffStaffAcquirersAcquirerIdOrdersImport } from './routes/u/$localId/_staff.staff/acquirers/$acquirerId/orders'
import { Route as ULocalIdStaffStaffAcquirersAcquirerIdMerchantsImport } from './routes/u/$localId/_staff.staff/acquirers/$acquirerId/merchants'
import { Route as ULocalIdStaffStaffAcquirersAcquirerIdLinksImport } from './routes/u/$localId/_staff.staff/acquirers/$acquirerId/links'
import { Route as ULocalIdStaffStaffAcquirersAcquirerIdApiKeysImport } from './routes/u/$localId/_staff.staff/acquirers/$acquirerId/api-keys'
import { Route as ULocalIdMerchantMerchantUsersIdEditImport } from './routes/u/$localId/_merchant.merchant/users/$id/edit'
import { Route as ULocalIdMerchantMerchantPaymentControlsTypeIdImport } from './routes/u/$localId/_merchant.merchant/payment-controls/$type/$id'
import { Route as ULocalIdMerchantMerchantOrdersIdTransactionsImport } from './routes/u/$localId/_merchant.merchant/orders/$id/transactions'
import { Route as ULocalIdMerchantMerchantOrdersIdSubMerchantImport } from './routes/u/$localId/_merchant.merchant/orders/$id/subMerchant'
import { Route as ULocalIdMerchantMerchantOrdersIdSourceImport } from './routes/u/$localId/_merchant.merchant/orders/$id/source'
import { Route as ULocalIdMerchantMerchantOrdersIdMerchantImport } from './routes/u/$localId/_merchant.merchant/orders/$id/merchant'
import { Route as ULocalIdMerchantMerchantOrdersIdApiResponseImport } from './routes/u/$localId/_merchant.merchant/orders/$id/apiResponse'
import { Route as ULocalIdMerchantMerchantOrdersIdAgreementImport } from './routes/u/$localId/_merchant.merchant/orders/$id/agreement'
import { Route as ULocalIdMerchantMerchantCardAuthenticationsIdMerchantImport } from './routes/u/$localId/_merchant.merchant/card-authentications/$id/merchant'
import { Route as ULocalIdMerchantMerchantCardAuthenticationsIdAuthImport } from './routes/u/$localId/_merchant.merchant/card-authentications/$id/auth'
import { Route as ULocalIdMerchantMerchantCardAuthenticationsIdApiResponseImport } from './routes/u/$localId/_merchant.merchant/card-authentications/$id/apiResponse'
import { Route as ULocalIdMerchantMerchantApiKeysIdEditImport } from './routes/u/$localId/_merchant.merchant/api-keys/$id/edit'
import { Route as ULocalIdMerchantMerchantAgreementsIdOrdersImport } from './routes/u/$localId/_merchant.merchant/agreements/$id/orders'
import { Route as ULocalIdMerchantMerchantAgreementsIdApiResponseImport } from './routes/u/$localId/_merchant.merchant/agreements/$id/api-response'
import { Route as ULocalIdAcquirerAcquirerUsersIdEditImport } from './routes/u/$localId/_acquirer.acquirer/users/$id/edit'
import { Route as ULocalIdAcquirerAcquirerPaymentControlsTypeIdImport } from './routes/u/$localId/_acquirer.acquirer/payment-controls/$type/$id'
import { Route as ULocalIdAcquirerAcquirerOrdersIdTransactionsImport } from './routes/u/$localId/_acquirer.acquirer/orders/$id/transactions'
import { Route as ULocalIdAcquirerAcquirerOrdersIdSubMerchantImport } from './routes/u/$localId/_acquirer.acquirer/orders/$id/subMerchant'
import { Route as ULocalIdAcquirerAcquirerOrdersIdSourceImport } from './routes/u/$localId/_acquirer.acquirer/orders/$id/source'
import { Route as ULocalIdAcquirerAcquirerOrdersIdMerchantImport } from './routes/u/$localId/_acquirer.acquirer/orders/$id/merchant'
import { Route as ULocalIdAcquirerAcquirerOrdersIdApiResponseImport } from './routes/u/$localId/_acquirer.acquirer/orders/$id/apiResponse'
import { Route as ULocalIdAcquirerAcquirerOrdersIdAgreementImport } from './routes/u/$localId/_acquirer.acquirer/orders/$id/agreement'
import { Route as ULocalIdAcquirerAcquirerMerchantsMerchantIdEditImport } from './routes/u/$localId/_acquirer.acquirer/merchants/$merchantId_/edit'
import { Route as ULocalIdAcquirerAcquirerMerchantsMerchantIdUsersImport } from './routes/u/$localId/_acquirer.acquirer/merchants/$merchantId/users'
import { Route as ULocalIdAcquirerAcquirerMerchantsMerchantIdTransactionsImport } from './routes/u/$localId/_acquirer.acquirer/merchants/$merchantId/transactions'
import { Route as ULocalIdAcquirerAcquirerMerchantsMerchantIdOrdersImport } from './routes/u/$localId/_acquirer.acquirer/merchants/$merchantId/orders'
import { Route as ULocalIdAcquirerAcquirerMerchantsMerchantIdLinksImport } from './routes/u/$localId/_acquirer.acquirer/merchants/$merchantId/links'
import { Route as ULocalIdAcquirerAcquirerMerchantsMerchantIdCardAuthenticationsImport } from './routes/u/$localId/_acquirer.acquirer/merchants/$merchantId/card-authentications'
import { Route as ULocalIdAcquirerAcquirerCardAuthenticationsIdMerchantImport } from './routes/u/$localId/_acquirer.acquirer/card-authentications/$id/merchant'
import { Route as ULocalIdAcquirerAcquirerCardAuthenticationsIdAuthImport } from './routes/u/$localId/_acquirer.acquirer/card-authentications/$id/auth'
import { Route as ULocalIdAcquirerAcquirerCardAuthenticationsIdApiResponseImport } from './routes/u/$localId/_acquirer.acquirer/card-authentications/$id/apiResponse'
import { Route as ULocalIdAcquirerAcquirerApiKeysIdEditImport } from './routes/u/$localId/_acquirer.acquirer/api-keys/$id/edit'
import { Route as ULocalIdAcquirerAcquirerAgreementsIdOrdersImport } from './routes/u/$localId/_acquirer.acquirer/agreements/$id/orders'
import { Route as ULocalIdAcquirerAcquirerAgreementsIdApiResponseImport } from './routes/u/$localId/_acquirer.acquirer/agreements/$id/api-response'
import { Route as ULocalIdStaffStaffMerchantsMerchantIdPaymentControlsIndexImport } from './routes/u/$localId/_staff.staff/merchants/$merchantId/payment-controls/index'
import { Route as ULocalIdStaffStaffAcquirersAcquirerIdPaymentControlsIndexImport } from './routes/u/$localId/_staff.staff/acquirers/$acquirerId/payment-controls/index'
import { Route as ULocalIdAcquirerAcquirerMerchantsMerchantIdPaymentControlsIndexImport } from './routes/u/$localId/_acquirer.acquirer/merchants/$merchantId/payment-controls/index'
import { Route as ULocalIdStaffStaffMerchantsMerchantIdUsersNewImport } from './routes/u/$localId/_staff.staff/merchants/$merchantId_/users_/new'
import { Route as ULocalIdStaffStaffMerchantsMerchantIdLinksNewImport } from './routes/u/$localId/_staff.staff/merchants/$merchantId_/links_/new'
import { Route as ULocalIdStaffStaffMerchantsMerchantIdApiKeysNewImport } from './routes/u/$localId/_staff.staff/merchants/$merchantId_/api-keys_/new'
import { Route as ULocalIdStaffStaffAcquirersAcquirerIdUsersNewImport } from './routes/u/$localId/_staff.staff/acquirers/$acquirerId_/users_/new'
import { Route as ULocalIdStaffStaffAcquirersAcquirerIdMerchantsNewImport } from './routes/u/$localId/_staff.staff/acquirers/$acquirerId_/merchants_/new'
import { Route as ULocalIdStaffStaffAcquirersAcquirerIdLinksNewImport } from './routes/u/$localId/_staff.staff/acquirers/$acquirerId_/links_/new'
import { Route as ULocalIdStaffStaffAcquirersAcquirerIdApiKeysNewImport } from './routes/u/$localId/_staff.staff/acquirers/$acquirerId_/api-keys_/new'
import { Route as ULocalIdAcquirerAcquirerMerchantsMerchantIdUsersNewImport } from './routes/u/$localId/_acquirer.acquirer/merchants/$merchantId_/users_/new'
import { Route as ULocalIdAcquirerAcquirerMerchantsMerchantIdLinksNewImport } from './routes/u/$localId/_acquirer.acquirer/merchants/$merchantId_/links_/new'
import { Route as ULocalIdStaffStaffMerchantsMerchantIdUsersIdIndexImport } from './routes/u/$localId/_staff.staff/merchants/$merchantId_/users_/$id.index'
import { Route as ULocalIdStaffStaffMerchantsMerchantIdLinksIdIndexImport } from './routes/u/$localId/_staff.staff/merchants/$merchantId_/links_/$id.index'
import { Route as ULocalIdStaffStaffMerchantsMerchantIdApiKeysIdIndexImport } from './routes/u/$localId/_staff.staff/merchants/$merchantId_/api-keys_/$id.index'
import { Route as ULocalIdStaffStaffMerchantsMerchantIdPaymentControlsTypeIndexImport } from './routes/u/$localId/_staff.staff/merchants/$merchantId/payment-controls/$type/index'
import { Route as ULocalIdStaffStaffAcquirersAcquirerIdUsersIdIndexImport } from './routes/u/$localId/_staff.staff/acquirers/$acquirerId_/users_/$id.index'
import { Route as ULocalIdStaffStaffAcquirersAcquirerIdLinksIdIndexImport } from './routes/u/$localId/_staff.staff/acquirers/$acquirerId_/links_/$id.index'
import { Route as ULocalIdStaffStaffAcquirersAcquirerIdApiKeysIdIndexImport } from './routes/u/$localId/_staff.staff/acquirers/$acquirerId_/api-keys_/$id.index'
import { Route as ULocalIdStaffStaffAcquirersAcquirerIdPaymentControlsTypeIndexImport } from './routes/u/$localId/_staff.staff/acquirers/$acquirerId/payment-controls/$type/index'
import { Route as ULocalIdAcquirerAcquirerMerchantsMerchantIdUsersIdIndexImport } from './routes/u/$localId/_acquirer.acquirer/merchants/$merchantId_/users_/$id.index'
import { Route as ULocalIdAcquirerAcquirerMerchantsMerchantIdLinksIdIndexImport } from './routes/u/$localId/_acquirer.acquirer/merchants/$merchantId_/links_/$id.index'
import { Route as ULocalIdAcquirerAcquirerMerchantsMerchantIdPaymentControlsTypeIndexImport } from './routes/u/$localId/_acquirer.acquirer/merchants/$merchantId/payment-controls/$type/index'
import { Route as ULocalIdStaffStaffMerchantsMerchantIdUsersIdEditImport } from './routes/u/$localId/_staff.staff/merchants/$merchantId_/users_/$id.edit'
import { Route as ULocalIdStaffStaffMerchantsMerchantIdPaymentControlsTypeIdImport } from './routes/u/$localId/_staff.staff/merchants/$merchantId_/payment-controls_/$type/$id'
import { Route as ULocalIdStaffStaffMerchantsMerchantIdLinksIdEditImport } from './routes/u/$localId/_staff.staff/merchants/$merchantId_/links_/$id.edit'
import { Route as ULocalIdStaffStaffMerchantsMerchantIdApiKeysIdEditImport } from './routes/u/$localId/_staff.staff/merchants/$merchantId_/api-keys_/$id.edit'
import { Route as ULocalIdStaffStaffAcquirersAcquirerIdUsersIdEditImport } from './routes/u/$localId/_staff.staff/acquirers/$acquirerId_/users_/$id.edit'
import { Route as ULocalIdStaffStaffAcquirersAcquirerIdPaymentControlsTypeIdImport } from './routes/u/$localId/_staff.staff/acquirers/$acquirerId_/payment-controls_/$type/$id'
import { Route as ULocalIdStaffStaffAcquirersAcquirerIdLinksIdEditImport } from './routes/u/$localId/_staff.staff/acquirers/$acquirerId_/links_/$id.edit'
import { Route as ULocalIdStaffStaffAcquirersAcquirerIdApiKeysIdEditImport } from './routes/u/$localId/_staff.staff/acquirers/$acquirerId_/api-keys_/$id.edit'
import { Route as ULocalIdAcquirerAcquirerMerchantsMerchantIdUsersIdEditImport } from './routes/u/$localId/_acquirer.acquirer/merchants/$merchantId_/users_/$id.edit'
import { Route as ULocalIdAcquirerAcquirerMerchantsMerchantIdPaymentControlsTypeIdImport } from './routes/u/$localId/_acquirer.acquirer/merchants/$merchantId_/payment-controls_/$type/$id'
import { Route as ULocalIdAcquirerAcquirerMerchantsMerchantIdLinksIdEditImport } from './routes/u/$localId/_acquirer.acquirer/merchants/$merchantId_/links_/$id.edit'

// Create Virtual Routes

const ULocalIdImport = createFileRoute('/u/$localId')()
const ULocalIdStaffStaffForbiddenLazyImport = createFileRoute(
  '/u/$localId/_staff/staff/forbidden',
)()
const ULocalIdMerchantMerchantForbiddenLazyImport = createFileRoute(
  '/u/$localId/_merchant/merchant/forbidden',
)()
const ULocalIdAcquirerAcquirerForbiddenLazyImport = createFileRoute(
  '/u/$localId/_acquirer/acquirer/forbidden',
)()

// Create/Update Routes

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const ULocalIdRoute = ULocalIdImport.update({
  path: '/u/$localId',
  getParentRoute: () => rootRoute,
} as any)

const UIndexRoute = UIndexImport.update({
  path: '/u/',
  getParentRoute: () => rootRoute,
} as any)

const StaffResetPasswordRoute = StaffResetPasswordImport.update({
  path: '/staff/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const StaffLoginRoute = StaffLoginImport.update({
  path: '/staff/login',
  getParentRoute: () => rootRoute,
} as any)

const StaffInvitationRoute = StaffInvitationImport.update({
  path: '/staff/invitation',
  getParentRoute: () => rootRoute,
} as any)

const MerchantResetPasswordRoute = MerchantResetPasswordImport.update({
  path: '/merchant/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const MerchantLoginRoute = MerchantLoginImport.update({
  path: '/merchant/login',
  getParentRoute: () => rootRoute,
} as any)

const MerchantInvitationRoute = MerchantInvitationImport.update({
  path: '/merchant/invitation',
  getParentRoute: () => rootRoute,
} as any)

const AcquirerResetPasswordRoute = AcquirerResetPasswordImport.update({
  path: '/acquirer/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const AcquirerLoginRoute = AcquirerLoginImport.update({
  path: '/acquirer/login',
  getParentRoute: () => rootRoute,
} as any)

const AcquirerInvitationRoute = AcquirerInvitationImport.update({
  path: '/acquirer/invitation',
  getParentRoute: () => rootRoute,
} as any)

const ULocalIdIndexRoute = ULocalIdIndexImport.update({
  path: '/',
  getParentRoute: () => ULocalIdRoute,
} as any)

const ULocalIdStaffRoute = ULocalIdStaffImport.update({
  id: '/_staff',
  getParentRoute: () => ULocalIdRoute,
} as any)

const ULocalIdMerchantRoute = ULocalIdMerchantImport.update({
  id: '/_merchant',
  getParentRoute: () => ULocalIdRoute,
} as any)

const ULocalIdAcquirerRoute = ULocalIdAcquirerImport.update({
  id: '/_acquirer',
  getParentRoute: () => ULocalIdRoute,
} as any)

const ULocalIdStaffStaffIndexRoute = ULocalIdStaffStaffIndexImport.update({
  path: '/staff/',
  getParentRoute: () => ULocalIdStaffRoute,
} as any)

const ULocalIdMerchantMerchantIndexRoute =
  ULocalIdMerchantMerchantIndexImport.update({
    path: '/merchant/',
    getParentRoute: () => ULocalIdMerchantRoute,
  } as any)

const ULocalIdAcquirerAcquirerIndexRoute =
  ULocalIdAcquirerAcquirerIndexImport.update({
    path: '/acquirer/',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdStaffStaffForbiddenLazyRoute =
  ULocalIdStaffStaffForbiddenLazyImport.update({
    path: '/staff/forbidden',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any).lazy(() =>
    import('./routes/u/$localId/_staff.staff/forbidden.lazy').then(
      (d) => d.Route,
    ),
  )

const ULocalIdMerchantMerchantForbiddenLazyRoute =
  ULocalIdMerchantMerchantForbiddenLazyImport.update({
    path: '/merchant/forbidden',
    getParentRoute: () => ULocalIdMerchantRoute,
  } as any).lazy(() =>
    import('./routes/u/$localId/_merchant.merchant/forbidden.lazy').then(
      (d) => d.Route,
    ),
  )

const ULocalIdAcquirerAcquirerForbiddenLazyRoute =
  ULocalIdAcquirerAcquirerForbiddenLazyImport.update({
    path: '/acquirer/forbidden',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any).lazy(() =>
    import('./routes/u/$localId/_acquirer.acquirer/forbidden.lazy').then(
      (d) => d.Route,
    ),
  )

const ULocalIdStaffStaffUsersIndexRoute =
  ULocalIdStaffStaffUsersIndexImport.update({
    path: '/staff/users/',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffTransactionsIndexRoute =
  ULocalIdStaffStaffTransactionsIndexImport.update({
    path: '/staff/transactions/',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffTdsMerchantsIndexRoute =
  ULocalIdStaffStaffTdsMerchantsIndexImport.update({
    path: '/staff/tds-merchants/',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffSettingsIndexRoute =
  ULocalIdStaffStaffSettingsIndexImport.update({
    path: '/staff/settings/',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffOrdersIndexRoute =
  ULocalIdStaffStaffOrdersIndexImport.update({
    path: '/staff/orders/',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffMerchantsIndexRoute =
  ULocalIdStaffStaffMerchantsIndexImport.update({
    path: '/staff/merchants/',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffCardAuthenticationsIndexRoute =
  ULocalIdStaffStaffCardAuthenticationsIndexImport.update({
    path: '/staff/card-authentications/',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffBenchUsersIndexRoute =
  ULocalIdStaffStaffBenchUsersIndexImport.update({
    path: '/staff/bench-users/',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffAuditLogsIndexRoute =
  ULocalIdStaffStaffAuditLogsIndexImport.update({
    path: '/staff/audit-logs/',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffAgreementsIndexRoute =
  ULocalIdStaffStaffAgreementsIndexImport.update({
    path: '/staff/agreements/',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffAcquirersIndexRoute =
  ULocalIdStaffStaffAcquirersIndexImport.update({
    path: '/staff/acquirers/',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdMerchantMerchantUsersIndexRoute =
  ULocalIdMerchantMerchantUsersIndexImport.update({
    path: '/merchant/users/',
    getParentRoute: () => ULocalIdMerchantRoute,
  } as any)

const ULocalIdMerchantMerchantTransactionsIndexRoute =
  ULocalIdMerchantMerchantTransactionsIndexImport.update({
    path: '/merchant/transactions/',
    getParentRoute: () => ULocalIdMerchantRoute,
  } as any)

const ULocalIdMerchantMerchantSettingsIndexRoute =
  ULocalIdMerchantMerchantSettingsIndexImport.update({
    path: '/merchant/settings/',
    getParentRoute: () => ULocalIdMerchantRoute,
  } as any)

const ULocalIdMerchantMerchantPaymentControlsIndexRoute =
  ULocalIdMerchantMerchantPaymentControlsIndexImport.update({
    path: '/merchant/payment-controls/',
    getParentRoute: () => ULocalIdMerchantRoute,
  } as any)

const ULocalIdMerchantMerchantOrdersIndexRoute =
  ULocalIdMerchantMerchantOrdersIndexImport.update({
    path: '/merchant/orders/',
    getParentRoute: () => ULocalIdMerchantRoute,
  } as any)

const ULocalIdMerchantMerchantLinksIndexRoute =
  ULocalIdMerchantMerchantLinksIndexImport.update({
    path: '/merchant/links/',
    getParentRoute: () => ULocalIdMerchantRoute,
  } as any)

const ULocalIdMerchantMerchantCardAuthenticationsIndexRoute =
  ULocalIdMerchantMerchantCardAuthenticationsIndexImport.update({
    path: '/merchant/card-authentications/',
    getParentRoute: () => ULocalIdMerchantRoute,
  } as any)

const ULocalIdMerchantMerchantAuditLogsIndexRoute =
  ULocalIdMerchantMerchantAuditLogsIndexImport.update({
    path: '/merchant/audit-logs/',
    getParentRoute: () => ULocalIdMerchantRoute,
  } as any)

const ULocalIdMerchantMerchantApiKeysIndexRoute =
  ULocalIdMerchantMerchantApiKeysIndexImport.update({
    path: '/merchant/api-keys/',
    getParentRoute: () => ULocalIdMerchantRoute,
  } as any)

const ULocalIdMerchantMerchantAgreementsIndexRoute =
  ULocalIdMerchantMerchantAgreementsIndexImport.update({
    path: '/merchant/agreements/',
    getParentRoute: () => ULocalIdMerchantRoute,
  } as any)

const ULocalIdAcquirerAcquirerUsersIndexRoute =
  ULocalIdAcquirerAcquirerUsersIndexImport.update({
    path: '/acquirer/users/',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerTransactionsIndexRoute =
  ULocalIdAcquirerAcquirerTransactionsIndexImport.update({
    path: '/acquirer/transactions/',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerSettingsIndexRoute =
  ULocalIdAcquirerAcquirerSettingsIndexImport.update({
    path: '/acquirer/settings/',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerPaymentControlsIndexRoute =
  ULocalIdAcquirerAcquirerPaymentControlsIndexImport.update({
    path: '/acquirer/payment-controls/',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerOrdersIndexRoute =
  ULocalIdAcquirerAcquirerOrdersIndexImport.update({
    path: '/acquirer/orders/',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerMerchantsIndexRoute =
  ULocalIdAcquirerAcquirerMerchantsIndexImport.update({
    path: '/acquirer/merchants/',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerLinksIndexRoute =
  ULocalIdAcquirerAcquirerLinksIndexImport.update({
    path: '/acquirer/links/',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerEodStatementsIndexRoute =
  ULocalIdAcquirerAcquirerEodStatementsIndexImport.update({
    path: '/acquirer/eod-statements/',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerCardAuthenticationsIndexRoute =
  ULocalIdAcquirerAcquirerCardAuthenticationsIndexImport.update({
    path: '/acquirer/card-authentications/',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerAuditLogsIndexRoute =
  ULocalIdAcquirerAcquirerAuditLogsIndexImport.update({
    path: '/acquirer/audit-logs/',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerApiKeysIndexRoute =
  ULocalIdAcquirerAcquirerApiKeysIndexImport.update({
    path: '/acquirer/api-keys/',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerAgreementsIndexRoute =
  ULocalIdAcquirerAcquirerAgreementsIndexImport.update({
    path: '/acquirer/agreements/',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdStaffStaffUsersNewRoute = ULocalIdStaffStaffUsersNewImport.update(
  {
    path: '/staff/users/new',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any,
)

const ULocalIdStaffStaffTdsMerchantsIdRoute =
  ULocalIdStaffStaffTdsMerchantsIdImport.update({
    path: '/staff/tds-merchants/$id',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffOrdersIdRoute = ULocalIdStaffStaffOrdersIdImport.update(
  {
    path: '/staff/orders/$id',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any,
)

const ULocalIdStaffStaffMerchantsMerchantIdRoute =
  ULocalIdStaffStaffMerchantsMerchantIdImport.update({
    path: '/staff/merchants/$merchantId',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffCardAuthenticationsIdRoute =
  ULocalIdStaffStaffCardAuthenticationsIdImport.update({
    path: '/staff/card-authentications/$id',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffBinsImportRoute =
  ULocalIdStaffStaffBinsImportImport.update({
    path: '/staff/bins/import',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffBenchUsersNewRoute =
  ULocalIdStaffStaffBenchUsersNewImport.update({
    path: '/staff/bench-users/new',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffAuditLogsIdRoute =
  ULocalIdStaffStaffAuditLogsIdImport.update({
    path: '/staff/audit-logs/$id',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffAgreementsIdRoute =
  ULocalIdStaffStaffAgreementsIdImport.update({
    path: '/staff/agreements/$id',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffAcquirersNewRoute =
  ULocalIdStaffStaffAcquirersNewImport.update({
    path: '/staff/acquirers/new',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffAcquirersAcquirerIdRoute =
  ULocalIdStaffStaffAcquirersAcquirerIdImport.update({
    path: '/staff/acquirers/$acquirerId',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdMerchantMerchantUsersNewRoute =
  ULocalIdMerchantMerchantUsersNewImport.update({
    path: '/merchant/users/new',
    getParentRoute: () => ULocalIdMerchantRoute,
  } as any)

const ULocalIdMerchantMerchantOrdersIdRoute =
  ULocalIdMerchantMerchantOrdersIdImport.update({
    path: '/merchant/orders/$id',
    getParentRoute: () => ULocalIdMerchantRoute,
  } as any)

const ULocalIdMerchantMerchantLinksIdRoute =
  ULocalIdMerchantMerchantLinksIdImport.update({
    path: '/merchant/links/$id',
    getParentRoute: () => ULocalIdMerchantRoute,
  } as any)

const ULocalIdMerchantMerchantCardAuthenticationsIdRoute =
  ULocalIdMerchantMerchantCardAuthenticationsIdImport.update({
    path: '/merchant/card-authentications/$id',
    getParentRoute: () => ULocalIdMerchantRoute,
  } as any)

const ULocalIdMerchantMerchantAuditLogsIdRoute =
  ULocalIdMerchantMerchantAuditLogsIdImport.update({
    path: '/merchant/audit-logs/$id',
    getParentRoute: () => ULocalIdMerchantRoute,
  } as any)

const ULocalIdMerchantMerchantApiKeysNewRoute =
  ULocalIdMerchantMerchantApiKeysNewImport.update({
    path: '/merchant/api-keys/new',
    getParentRoute: () => ULocalIdMerchantRoute,
  } as any)

const ULocalIdMerchantMerchantAgreementsIdRoute =
  ULocalIdMerchantMerchantAgreementsIdImport.update({
    path: '/merchant/agreements/$id',
    getParentRoute: () => ULocalIdMerchantRoute,
  } as any)

const ULocalIdAcquirerAcquirerUsersNewRoute =
  ULocalIdAcquirerAcquirerUsersNewImport.update({
    path: '/acquirer/users/new',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerOrdersIdRoute =
  ULocalIdAcquirerAcquirerOrdersIdImport.update({
    path: '/acquirer/orders/$id',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerMerchantsNewRoute =
  ULocalIdAcquirerAcquirerMerchantsNewImport.update({
    path: '/acquirer/merchants/new',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerMerchantsMerchantIdRoute =
  ULocalIdAcquirerAcquirerMerchantsMerchantIdImport.update({
    path: '/acquirer/merchants/$merchantId',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerLinksIdRoute =
  ULocalIdAcquirerAcquirerLinksIdImport.update({
    path: '/acquirer/links/$id',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerCardAuthenticationsIdRoute =
  ULocalIdAcquirerAcquirerCardAuthenticationsIdImport.update({
    path: '/acquirer/card-authentications/$id',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerAuditLogsIdRoute =
  ULocalIdAcquirerAcquirerAuditLogsIdImport.update({
    path: '/acquirer/audit-logs/$id',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerApiKeysNewRoute =
  ULocalIdAcquirerAcquirerApiKeysNewImport.update({
    path: '/acquirer/api-keys/new',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerAgreementsIdRoute =
  ULocalIdAcquirerAcquirerAgreementsIdImport.update({
    path: '/acquirer/agreements/$id',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdStaffStaffUsersIdIndexRoute =
  ULocalIdStaffStaffUsersIdIndexImport.update({
    path: '/staff/users/$id/',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdMerchantMerchantUsersIdIndexRoute =
  ULocalIdMerchantMerchantUsersIdIndexImport.update({
    path: '/merchant/users/$id/',
    getParentRoute: () => ULocalIdMerchantRoute,
  } as any)

const ULocalIdMerchantMerchantPaymentControlsTypeIndexRoute =
  ULocalIdMerchantMerchantPaymentControlsTypeIndexImport.update({
    path: '/merchant/payment-controls/$type/',
    getParentRoute: () => ULocalIdMerchantRoute,
  } as any)

const ULocalIdMerchantMerchantApiKeysIdIndexRoute =
  ULocalIdMerchantMerchantApiKeysIdIndexImport.update({
    path: '/merchant/api-keys/$id/',
    getParentRoute: () => ULocalIdMerchantRoute,
  } as any)

const ULocalIdAcquirerAcquirerUsersIdIndexRoute =
  ULocalIdAcquirerAcquirerUsersIdIndexImport.update({
    path: '/acquirer/users/$id/',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerPaymentControlsTypeIndexRoute =
  ULocalIdAcquirerAcquirerPaymentControlsTypeIndexImport.update({
    path: '/acquirer/payment-controls/$type/',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerApiKeysIdIndexRoute =
  ULocalIdAcquirerAcquirerApiKeysIdIndexImport.update({
    path: '/acquirer/api-keys/$id/',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdStaffStaffUsersIdEditRoute =
  ULocalIdStaffStaffUsersIdEditImport.update({
    path: '/staff/users/$id/edit',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffOrdersIdTransactionsRoute =
  ULocalIdStaffStaffOrdersIdTransactionsImport.update({
    path: '/transactions',
    getParentRoute: () => ULocalIdStaffStaffOrdersIdRoute,
  } as any)

const ULocalIdStaffStaffOrdersIdSubMerchantRoute =
  ULocalIdStaffStaffOrdersIdSubMerchantImport.update({
    path: '/subMerchant',
    getParentRoute: () => ULocalIdStaffStaffOrdersIdRoute,
  } as any)

const ULocalIdStaffStaffOrdersIdSourceRoute =
  ULocalIdStaffStaffOrdersIdSourceImport.update({
    path: '/source',
    getParentRoute: () => ULocalIdStaffStaffOrdersIdRoute,
  } as any)

const ULocalIdStaffStaffOrdersIdMerchantRoute =
  ULocalIdStaffStaffOrdersIdMerchantImport.update({
    path: '/merchant',
    getParentRoute: () => ULocalIdStaffStaffOrdersIdRoute,
  } as any)

const ULocalIdStaffStaffOrdersIdApiResponseRoute =
  ULocalIdStaffStaffOrdersIdApiResponseImport.update({
    path: '/apiResponse',
    getParentRoute: () => ULocalIdStaffStaffOrdersIdRoute,
  } as any)

const ULocalIdStaffStaffOrdersIdAgreementRoute =
  ULocalIdStaffStaffOrdersIdAgreementImport.update({
    path: '/agreement',
    getParentRoute: () => ULocalIdStaffStaffOrdersIdRoute,
  } as any)

const ULocalIdStaffStaffMerchantsMerchantIdEditRoute =
  ULocalIdStaffStaffMerchantsMerchantIdEditImport.update({
    path: '/staff/merchants/$merchantId/edit',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffMerchantsMerchantIdUsersRoute =
  ULocalIdStaffStaffMerchantsMerchantIdUsersImport.update({
    path: '/users',
    getParentRoute: () => ULocalIdStaffStaffMerchantsMerchantIdRoute,
  } as any)

const ULocalIdStaffStaffMerchantsMerchantIdTransactionsRoute =
  ULocalIdStaffStaffMerchantsMerchantIdTransactionsImport.update({
    path: '/transactions',
    getParentRoute: () => ULocalIdStaffStaffMerchantsMerchantIdRoute,
  } as any)

const ULocalIdStaffStaffMerchantsMerchantIdOrdersRoute =
  ULocalIdStaffStaffMerchantsMerchantIdOrdersImport.update({
    path: '/orders',
    getParentRoute: () => ULocalIdStaffStaffMerchantsMerchantIdRoute,
  } as any)

const ULocalIdStaffStaffMerchantsMerchantIdLinksRoute =
  ULocalIdStaffStaffMerchantsMerchantIdLinksImport.update({
    path: '/links',
    getParentRoute: () => ULocalIdStaffStaffMerchantsMerchantIdRoute,
  } as any)

const ULocalIdStaffStaffMerchantsMerchantIdApiKeysRoute =
  ULocalIdStaffStaffMerchantsMerchantIdApiKeysImport.update({
    path: '/api-keys',
    getParentRoute: () => ULocalIdStaffStaffMerchantsMerchantIdRoute,
  } as any)

const ULocalIdStaffStaffCardAuthenticationsIdMerchantRoute =
  ULocalIdStaffStaffCardAuthenticationsIdMerchantImport.update({
    path: '/merchant',
    getParentRoute: () => ULocalIdStaffStaffCardAuthenticationsIdRoute,
  } as any)

const ULocalIdStaffStaffCardAuthenticationsIdAuthRoute =
  ULocalIdStaffStaffCardAuthenticationsIdAuthImport.update({
    path: '/auth',
    getParentRoute: () => ULocalIdStaffStaffCardAuthenticationsIdRoute,
  } as any)

const ULocalIdStaffStaffCardAuthenticationsIdApiResponseRoute =
  ULocalIdStaffStaffCardAuthenticationsIdApiResponseImport.update({
    path: '/apiResponse',
    getParentRoute: () => ULocalIdStaffStaffCardAuthenticationsIdRoute,
  } as any)

const ULocalIdStaffStaffBenchUsersIdEditRoute =
  ULocalIdStaffStaffBenchUsersIdEditImport.update({
    path: '/staff/bench-users/$id/edit',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffAgreementsIdOrdersRoute =
  ULocalIdStaffStaffAgreementsIdOrdersImport.update({
    path: '/orders',
    getParentRoute: () => ULocalIdStaffStaffAgreementsIdRoute,
  } as any)

const ULocalIdStaffStaffAgreementsIdApiResponseRoute =
  ULocalIdStaffStaffAgreementsIdApiResponseImport.update({
    path: '/api-response',
    getParentRoute: () => ULocalIdStaffStaffAgreementsIdRoute,
  } as any)

const ULocalIdStaffStaffAcquirersAcquirerIdEditRoute =
  ULocalIdStaffStaffAcquirersAcquirerIdEditImport.update({
    path: '/staff/acquirers/$acquirerId/edit',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffAcquirersAcquirerIdUsersRoute =
  ULocalIdStaffStaffAcquirersAcquirerIdUsersImport.update({
    path: '/users',
    getParentRoute: () => ULocalIdStaffStaffAcquirersAcquirerIdRoute,
  } as any)

const ULocalIdStaffStaffAcquirersAcquirerIdTransactionsRoute =
  ULocalIdStaffStaffAcquirersAcquirerIdTransactionsImport.update({
    path: '/transactions',
    getParentRoute: () => ULocalIdStaffStaffAcquirersAcquirerIdRoute,
  } as any)

const ULocalIdStaffStaffAcquirersAcquirerIdOrdersRoute =
  ULocalIdStaffStaffAcquirersAcquirerIdOrdersImport.update({
    path: '/orders',
    getParentRoute: () => ULocalIdStaffStaffAcquirersAcquirerIdRoute,
  } as any)

const ULocalIdStaffStaffAcquirersAcquirerIdMerchantsRoute =
  ULocalIdStaffStaffAcquirersAcquirerIdMerchantsImport.update({
    path: '/merchants',
    getParentRoute: () => ULocalIdStaffStaffAcquirersAcquirerIdRoute,
  } as any)

const ULocalIdStaffStaffAcquirersAcquirerIdLinksRoute =
  ULocalIdStaffStaffAcquirersAcquirerIdLinksImport.update({
    path: '/links',
    getParentRoute: () => ULocalIdStaffStaffAcquirersAcquirerIdRoute,
  } as any)

const ULocalIdStaffStaffAcquirersAcquirerIdApiKeysRoute =
  ULocalIdStaffStaffAcquirersAcquirerIdApiKeysImport.update({
    path: '/api-keys',
    getParentRoute: () => ULocalIdStaffStaffAcquirersAcquirerIdRoute,
  } as any)

const ULocalIdMerchantMerchantUsersIdEditRoute =
  ULocalIdMerchantMerchantUsersIdEditImport.update({
    path: '/merchant/users/$id/edit',
    getParentRoute: () => ULocalIdMerchantRoute,
  } as any)

const ULocalIdMerchantMerchantPaymentControlsTypeIdRoute =
  ULocalIdMerchantMerchantPaymentControlsTypeIdImport.update({
    path: '/merchant/payment-controls/$type/$id',
    getParentRoute: () => ULocalIdMerchantRoute,
  } as any)

const ULocalIdMerchantMerchantOrdersIdTransactionsRoute =
  ULocalIdMerchantMerchantOrdersIdTransactionsImport.update({
    path: '/transactions',
    getParentRoute: () => ULocalIdMerchantMerchantOrdersIdRoute,
  } as any)

const ULocalIdMerchantMerchantOrdersIdSubMerchantRoute =
  ULocalIdMerchantMerchantOrdersIdSubMerchantImport.update({
    path: '/subMerchant',
    getParentRoute: () => ULocalIdMerchantMerchantOrdersIdRoute,
  } as any)

const ULocalIdMerchantMerchantOrdersIdSourceRoute =
  ULocalIdMerchantMerchantOrdersIdSourceImport.update({
    path: '/source',
    getParentRoute: () => ULocalIdMerchantMerchantOrdersIdRoute,
  } as any)

const ULocalIdMerchantMerchantOrdersIdMerchantRoute =
  ULocalIdMerchantMerchantOrdersIdMerchantImport.update({
    path: '/merchant',
    getParentRoute: () => ULocalIdMerchantMerchantOrdersIdRoute,
  } as any)

const ULocalIdMerchantMerchantOrdersIdApiResponseRoute =
  ULocalIdMerchantMerchantOrdersIdApiResponseImport.update({
    path: '/apiResponse',
    getParentRoute: () => ULocalIdMerchantMerchantOrdersIdRoute,
  } as any)

const ULocalIdMerchantMerchantOrdersIdAgreementRoute =
  ULocalIdMerchantMerchantOrdersIdAgreementImport.update({
    path: '/agreement',
    getParentRoute: () => ULocalIdMerchantMerchantOrdersIdRoute,
  } as any)

const ULocalIdMerchantMerchantCardAuthenticationsIdMerchantRoute =
  ULocalIdMerchantMerchantCardAuthenticationsIdMerchantImport.update({
    path: '/merchant',
    getParentRoute: () => ULocalIdMerchantMerchantCardAuthenticationsIdRoute,
  } as any)

const ULocalIdMerchantMerchantCardAuthenticationsIdAuthRoute =
  ULocalIdMerchantMerchantCardAuthenticationsIdAuthImport.update({
    path: '/auth',
    getParentRoute: () => ULocalIdMerchantMerchantCardAuthenticationsIdRoute,
  } as any)

const ULocalIdMerchantMerchantCardAuthenticationsIdApiResponseRoute =
  ULocalIdMerchantMerchantCardAuthenticationsIdApiResponseImport.update({
    path: '/apiResponse',
    getParentRoute: () => ULocalIdMerchantMerchantCardAuthenticationsIdRoute,
  } as any)

const ULocalIdMerchantMerchantApiKeysIdEditRoute =
  ULocalIdMerchantMerchantApiKeysIdEditImport.update({
    path: '/merchant/api-keys/$id/edit',
    getParentRoute: () => ULocalIdMerchantRoute,
  } as any)

const ULocalIdMerchantMerchantAgreementsIdOrdersRoute =
  ULocalIdMerchantMerchantAgreementsIdOrdersImport.update({
    path: '/orders',
    getParentRoute: () => ULocalIdMerchantMerchantAgreementsIdRoute,
  } as any)

const ULocalIdMerchantMerchantAgreementsIdApiResponseRoute =
  ULocalIdMerchantMerchantAgreementsIdApiResponseImport.update({
    path: '/api-response',
    getParentRoute: () => ULocalIdMerchantMerchantAgreementsIdRoute,
  } as any)

const ULocalIdAcquirerAcquirerUsersIdEditRoute =
  ULocalIdAcquirerAcquirerUsersIdEditImport.update({
    path: '/acquirer/users/$id/edit',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerPaymentControlsTypeIdRoute =
  ULocalIdAcquirerAcquirerPaymentControlsTypeIdImport.update({
    path: '/acquirer/payment-controls/$type/$id',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerOrdersIdTransactionsRoute =
  ULocalIdAcquirerAcquirerOrdersIdTransactionsImport.update({
    path: '/transactions',
    getParentRoute: () => ULocalIdAcquirerAcquirerOrdersIdRoute,
  } as any)

const ULocalIdAcquirerAcquirerOrdersIdSubMerchantRoute =
  ULocalIdAcquirerAcquirerOrdersIdSubMerchantImport.update({
    path: '/subMerchant',
    getParentRoute: () => ULocalIdAcquirerAcquirerOrdersIdRoute,
  } as any)

const ULocalIdAcquirerAcquirerOrdersIdSourceRoute =
  ULocalIdAcquirerAcquirerOrdersIdSourceImport.update({
    path: '/source',
    getParentRoute: () => ULocalIdAcquirerAcquirerOrdersIdRoute,
  } as any)

const ULocalIdAcquirerAcquirerOrdersIdMerchantRoute =
  ULocalIdAcquirerAcquirerOrdersIdMerchantImport.update({
    path: '/merchant',
    getParentRoute: () => ULocalIdAcquirerAcquirerOrdersIdRoute,
  } as any)

const ULocalIdAcquirerAcquirerOrdersIdApiResponseRoute =
  ULocalIdAcquirerAcquirerOrdersIdApiResponseImport.update({
    path: '/apiResponse',
    getParentRoute: () => ULocalIdAcquirerAcquirerOrdersIdRoute,
  } as any)

const ULocalIdAcquirerAcquirerOrdersIdAgreementRoute =
  ULocalIdAcquirerAcquirerOrdersIdAgreementImport.update({
    path: '/agreement',
    getParentRoute: () => ULocalIdAcquirerAcquirerOrdersIdRoute,
  } as any)

const ULocalIdAcquirerAcquirerMerchantsMerchantIdEditRoute =
  ULocalIdAcquirerAcquirerMerchantsMerchantIdEditImport.update({
    path: '/acquirer/merchants/$merchantId/edit',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerMerchantsMerchantIdUsersRoute =
  ULocalIdAcquirerAcquirerMerchantsMerchantIdUsersImport.update({
    path: '/users',
    getParentRoute: () => ULocalIdAcquirerAcquirerMerchantsMerchantIdRoute,
  } as any)

const ULocalIdAcquirerAcquirerMerchantsMerchantIdTransactionsRoute =
  ULocalIdAcquirerAcquirerMerchantsMerchantIdTransactionsImport.update({
    path: '/transactions',
    getParentRoute: () => ULocalIdAcquirerAcquirerMerchantsMerchantIdRoute,
  } as any)

const ULocalIdAcquirerAcquirerMerchantsMerchantIdOrdersRoute =
  ULocalIdAcquirerAcquirerMerchantsMerchantIdOrdersImport.update({
    path: '/orders',
    getParentRoute: () => ULocalIdAcquirerAcquirerMerchantsMerchantIdRoute,
  } as any)

const ULocalIdAcquirerAcquirerMerchantsMerchantIdLinksRoute =
  ULocalIdAcquirerAcquirerMerchantsMerchantIdLinksImport.update({
    path: '/links',
    getParentRoute: () => ULocalIdAcquirerAcquirerMerchantsMerchantIdRoute,
  } as any)

const ULocalIdAcquirerAcquirerMerchantsMerchantIdCardAuthenticationsRoute =
  ULocalIdAcquirerAcquirerMerchantsMerchantIdCardAuthenticationsImport.update({
    path: '/card-authentications',
    getParentRoute: () => ULocalIdAcquirerAcquirerMerchantsMerchantIdRoute,
  } as any)

const ULocalIdAcquirerAcquirerCardAuthenticationsIdMerchantRoute =
  ULocalIdAcquirerAcquirerCardAuthenticationsIdMerchantImport.update({
    path: '/merchant',
    getParentRoute: () => ULocalIdAcquirerAcquirerCardAuthenticationsIdRoute,
  } as any)

const ULocalIdAcquirerAcquirerCardAuthenticationsIdAuthRoute =
  ULocalIdAcquirerAcquirerCardAuthenticationsIdAuthImport.update({
    path: '/auth',
    getParentRoute: () => ULocalIdAcquirerAcquirerCardAuthenticationsIdRoute,
  } as any)

const ULocalIdAcquirerAcquirerCardAuthenticationsIdApiResponseRoute =
  ULocalIdAcquirerAcquirerCardAuthenticationsIdApiResponseImport.update({
    path: '/apiResponse',
    getParentRoute: () => ULocalIdAcquirerAcquirerCardAuthenticationsIdRoute,
  } as any)

const ULocalIdAcquirerAcquirerApiKeysIdEditRoute =
  ULocalIdAcquirerAcquirerApiKeysIdEditImport.update({
    path: '/acquirer/api-keys/$id/edit',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerAgreementsIdOrdersRoute =
  ULocalIdAcquirerAcquirerAgreementsIdOrdersImport.update({
    path: '/orders',
    getParentRoute: () => ULocalIdAcquirerAcquirerAgreementsIdRoute,
  } as any)

const ULocalIdAcquirerAcquirerAgreementsIdApiResponseRoute =
  ULocalIdAcquirerAcquirerAgreementsIdApiResponseImport.update({
    path: '/api-response',
    getParentRoute: () => ULocalIdAcquirerAcquirerAgreementsIdRoute,
  } as any)

const ULocalIdStaffStaffMerchantsMerchantIdPaymentControlsIndexRoute =
  ULocalIdStaffStaffMerchantsMerchantIdPaymentControlsIndexImport.update({
    path: '/payment-controls/',
    getParentRoute: () => ULocalIdStaffStaffMerchantsMerchantIdRoute,
  } as any)

const ULocalIdStaffStaffAcquirersAcquirerIdPaymentControlsIndexRoute =
  ULocalIdStaffStaffAcquirersAcquirerIdPaymentControlsIndexImport.update({
    path: '/payment-controls/',
    getParentRoute: () => ULocalIdStaffStaffAcquirersAcquirerIdRoute,
  } as any)

const ULocalIdAcquirerAcquirerMerchantsMerchantIdPaymentControlsIndexRoute =
  ULocalIdAcquirerAcquirerMerchantsMerchantIdPaymentControlsIndexImport.update({
    path: '/payment-controls/',
    getParentRoute: () => ULocalIdAcquirerAcquirerMerchantsMerchantIdRoute,
  } as any)

const ULocalIdStaffStaffMerchantsMerchantIdUsersNewRoute =
  ULocalIdStaffStaffMerchantsMerchantIdUsersNewImport.update({
    path: '/staff/merchants/$merchantId/users/new',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffMerchantsMerchantIdLinksNewRoute =
  ULocalIdStaffStaffMerchantsMerchantIdLinksNewImport.update({
    path: '/staff/merchants/$merchantId/links/new',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffMerchantsMerchantIdApiKeysNewRoute =
  ULocalIdStaffStaffMerchantsMerchantIdApiKeysNewImport.update({
    path: '/staff/merchants/$merchantId/api-keys/new',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffAcquirersAcquirerIdUsersNewRoute =
  ULocalIdStaffStaffAcquirersAcquirerIdUsersNewImport.update({
    path: '/staff/acquirers/$acquirerId/users/new',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffAcquirersAcquirerIdMerchantsNewRoute =
  ULocalIdStaffStaffAcquirersAcquirerIdMerchantsNewImport.update({
    path: '/staff/acquirers/$acquirerId/merchants/new',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffAcquirersAcquirerIdLinksNewRoute =
  ULocalIdStaffStaffAcquirersAcquirerIdLinksNewImport.update({
    path: '/staff/acquirers/$acquirerId/links/new',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffAcquirersAcquirerIdApiKeysNewRoute =
  ULocalIdStaffStaffAcquirersAcquirerIdApiKeysNewImport.update({
    path: '/staff/acquirers/$acquirerId/api-keys/new',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdAcquirerAcquirerMerchantsMerchantIdUsersNewRoute =
  ULocalIdAcquirerAcquirerMerchantsMerchantIdUsersNewImport.update({
    path: '/acquirer/merchants/$merchantId/users/new',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerMerchantsMerchantIdLinksNewRoute =
  ULocalIdAcquirerAcquirerMerchantsMerchantIdLinksNewImport.update({
    path: '/acquirer/merchants/$merchantId/links/new',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdStaffStaffMerchantsMerchantIdUsersIdIndexRoute =
  ULocalIdStaffStaffMerchantsMerchantIdUsersIdIndexImport.update({
    path: '/staff/merchants/$merchantId/users/$id/',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffMerchantsMerchantIdLinksIdIndexRoute =
  ULocalIdStaffStaffMerchantsMerchantIdLinksIdIndexImport.update({
    path: '/staff/merchants/$merchantId/links/$id/',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffMerchantsMerchantIdApiKeysIdIndexRoute =
  ULocalIdStaffStaffMerchantsMerchantIdApiKeysIdIndexImport.update({
    path: '/staff/merchants/$merchantId/api-keys/$id/',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffMerchantsMerchantIdPaymentControlsTypeIndexRoute =
  ULocalIdStaffStaffMerchantsMerchantIdPaymentControlsTypeIndexImport.update({
    path: '/payment-controls/$type/',
    getParentRoute: () => ULocalIdStaffStaffMerchantsMerchantIdRoute,
  } as any)

const ULocalIdStaffStaffAcquirersAcquirerIdUsersIdIndexRoute =
  ULocalIdStaffStaffAcquirersAcquirerIdUsersIdIndexImport.update({
    path: '/staff/acquirers/$acquirerId/users/$id/',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffAcquirersAcquirerIdLinksIdIndexRoute =
  ULocalIdStaffStaffAcquirersAcquirerIdLinksIdIndexImport.update({
    path: '/staff/acquirers/$acquirerId/links/$id/',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffAcquirersAcquirerIdApiKeysIdIndexRoute =
  ULocalIdStaffStaffAcquirersAcquirerIdApiKeysIdIndexImport.update({
    path: '/staff/acquirers/$acquirerId/api-keys/$id/',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffAcquirersAcquirerIdPaymentControlsTypeIndexRoute =
  ULocalIdStaffStaffAcquirersAcquirerIdPaymentControlsTypeIndexImport.update({
    path: '/payment-controls/$type/',
    getParentRoute: () => ULocalIdStaffStaffAcquirersAcquirerIdRoute,
  } as any)

const ULocalIdAcquirerAcquirerMerchantsMerchantIdUsersIdIndexRoute =
  ULocalIdAcquirerAcquirerMerchantsMerchantIdUsersIdIndexImport.update({
    path: '/acquirer/merchants/$merchantId/users/$id/',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerMerchantsMerchantIdLinksIdIndexRoute =
  ULocalIdAcquirerAcquirerMerchantsMerchantIdLinksIdIndexImport.update({
    path: '/acquirer/merchants/$merchantId/links/$id/',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerMerchantsMerchantIdPaymentControlsTypeIndexRoute =
  ULocalIdAcquirerAcquirerMerchantsMerchantIdPaymentControlsTypeIndexImport.update(
    {
      path: '/payment-controls/$type/',
      getParentRoute: () => ULocalIdAcquirerAcquirerMerchantsMerchantIdRoute,
    } as any,
  )

const ULocalIdStaffStaffMerchantsMerchantIdUsersIdEditRoute =
  ULocalIdStaffStaffMerchantsMerchantIdUsersIdEditImport.update({
    path: '/staff/merchants/$merchantId/users/$id/edit',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffMerchantsMerchantIdPaymentControlsTypeIdRoute =
  ULocalIdStaffStaffMerchantsMerchantIdPaymentControlsTypeIdImport.update({
    path: '/staff/merchants/$merchantId/payment-controls/$type/$id',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffMerchantsMerchantIdLinksIdEditRoute =
  ULocalIdStaffStaffMerchantsMerchantIdLinksIdEditImport.update({
    path: '/staff/merchants/$merchantId/links/$id/edit',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffMerchantsMerchantIdApiKeysIdEditRoute =
  ULocalIdStaffStaffMerchantsMerchantIdApiKeysIdEditImport.update({
    path: '/staff/merchants/$merchantId/api-keys/$id/edit',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffAcquirersAcquirerIdUsersIdEditRoute =
  ULocalIdStaffStaffAcquirersAcquirerIdUsersIdEditImport.update({
    path: '/staff/acquirers/$acquirerId/users/$id/edit',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffAcquirersAcquirerIdPaymentControlsTypeIdRoute =
  ULocalIdStaffStaffAcquirersAcquirerIdPaymentControlsTypeIdImport.update({
    path: '/staff/acquirers/$acquirerId/payment-controls/$type/$id',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffAcquirersAcquirerIdLinksIdEditRoute =
  ULocalIdStaffStaffAcquirersAcquirerIdLinksIdEditImport.update({
    path: '/staff/acquirers/$acquirerId/links/$id/edit',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdStaffStaffAcquirersAcquirerIdApiKeysIdEditRoute =
  ULocalIdStaffStaffAcquirersAcquirerIdApiKeysIdEditImport.update({
    path: '/staff/acquirers/$acquirerId/api-keys/$id/edit',
    getParentRoute: () => ULocalIdStaffRoute,
  } as any)

const ULocalIdAcquirerAcquirerMerchantsMerchantIdUsersIdEditRoute =
  ULocalIdAcquirerAcquirerMerchantsMerchantIdUsersIdEditImport.update({
    path: '/acquirer/merchants/$merchantId/users/$id/edit',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

const ULocalIdAcquirerAcquirerMerchantsMerchantIdPaymentControlsTypeIdRoute =
  ULocalIdAcquirerAcquirerMerchantsMerchantIdPaymentControlsTypeIdImport.update(
    {
      path: '/acquirer/merchants/$merchantId/payment-controls/$type/$id',
      getParentRoute: () => ULocalIdAcquirerRoute,
    } as any,
  )

const ULocalIdAcquirerAcquirerMerchantsMerchantIdLinksIdEditRoute =
  ULocalIdAcquirerAcquirerMerchantsMerchantIdLinksIdEditImport.update({
    path: '/acquirer/merchants/$merchantId/links/$id/edit',
    getParentRoute: () => ULocalIdAcquirerRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/acquirer/invitation': {
      id: '/acquirer/invitation'
      path: '/acquirer/invitation'
      fullPath: '/acquirer/invitation'
      preLoaderRoute: typeof AcquirerInvitationImport
      parentRoute: typeof rootRoute
    }
    '/acquirer/login': {
      id: '/acquirer/login'
      path: '/acquirer/login'
      fullPath: '/acquirer/login'
      preLoaderRoute: typeof AcquirerLoginImport
      parentRoute: typeof rootRoute
    }
    '/acquirer/reset-password': {
      id: '/acquirer/reset-password'
      path: '/acquirer/reset-password'
      fullPath: '/acquirer/reset-password'
      preLoaderRoute: typeof AcquirerResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/merchant/invitation': {
      id: '/merchant/invitation'
      path: '/merchant/invitation'
      fullPath: '/merchant/invitation'
      preLoaderRoute: typeof MerchantInvitationImport
      parentRoute: typeof rootRoute
    }
    '/merchant/login': {
      id: '/merchant/login'
      path: '/merchant/login'
      fullPath: '/merchant/login'
      preLoaderRoute: typeof MerchantLoginImport
      parentRoute: typeof rootRoute
    }
    '/merchant/reset-password': {
      id: '/merchant/reset-password'
      path: '/merchant/reset-password'
      fullPath: '/merchant/reset-password'
      preLoaderRoute: typeof MerchantResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/staff/invitation': {
      id: '/staff/invitation'
      path: '/staff/invitation'
      fullPath: '/staff/invitation'
      preLoaderRoute: typeof StaffInvitationImport
      parentRoute: typeof rootRoute
    }
    '/staff/login': {
      id: '/staff/login'
      path: '/staff/login'
      fullPath: '/staff/login'
      preLoaderRoute: typeof StaffLoginImport
      parentRoute: typeof rootRoute
    }
    '/staff/reset-password': {
      id: '/staff/reset-password'
      path: '/staff/reset-password'
      fullPath: '/staff/reset-password'
      preLoaderRoute: typeof StaffResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/u/': {
      id: '/u/'
      path: '/u'
      fullPath: '/u'
      preLoaderRoute: typeof UIndexImport
      parentRoute: typeof rootRoute
    }
    '/u/$localId': {
      id: '/u/$localId'
      path: '/u/$localId'
      fullPath: '/u/$localId'
      preLoaderRoute: typeof ULocalIdImport
      parentRoute: typeof rootRoute
    }
    '/u/$localId/_acquirer': {
      id: '/u/$localId/_acquirer'
      path: '/u/$localId'
      fullPath: '/u/$localId'
      preLoaderRoute: typeof ULocalIdAcquirerImport
      parentRoute: typeof ULocalIdRoute
    }
    '/u/$localId/_merchant': {
      id: '/u/$localId/_merchant'
      path: ''
      fullPath: '/u/$localId'
      preLoaderRoute: typeof ULocalIdMerchantImport
      parentRoute: typeof ULocalIdImport
    }
    '/u/$localId/_staff': {
      id: '/u/$localId/_staff'
      path: ''
      fullPath: '/u/$localId'
      preLoaderRoute: typeof ULocalIdStaffImport
      parentRoute: typeof ULocalIdImport
    }
    '/u/$localId/': {
      id: '/u/$localId/'
      path: '/'
      fullPath: '/u/$localId/'
      preLoaderRoute: typeof ULocalIdIndexImport
      parentRoute: typeof ULocalIdImport
    }
    '/u/$localId/_acquirer/acquirer/forbidden': {
      id: '/u/$localId/_acquirer/acquirer/forbidden'
      path: '/acquirer/forbidden'
      fullPath: '/u/$localId/acquirer/forbidden'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerForbiddenLazyImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_merchant/merchant/forbidden': {
      id: '/u/$localId/_merchant/merchant/forbidden'
      path: '/merchant/forbidden'
      fullPath: '/u/$localId/merchant/forbidden'
      preLoaderRoute: typeof ULocalIdMerchantMerchantForbiddenLazyImport
      parentRoute: typeof ULocalIdMerchantImport
    }
    '/u/$localId/_staff/staff/forbidden': {
      id: '/u/$localId/_staff/staff/forbidden'
      path: '/staff/forbidden'
      fullPath: '/u/$localId/staff/forbidden'
      preLoaderRoute: typeof ULocalIdStaffStaffForbiddenLazyImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_acquirer/acquirer/': {
      id: '/u/$localId/_acquirer/acquirer/'
      path: '/acquirer'
      fullPath: '/u/$localId/acquirer'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerIndexImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_merchant/merchant/': {
      id: '/u/$localId/_merchant/merchant/'
      path: '/merchant'
      fullPath: '/u/$localId/merchant'
      preLoaderRoute: typeof ULocalIdMerchantMerchantIndexImport
      parentRoute: typeof ULocalIdMerchantImport
    }
    '/u/$localId/_staff/staff/': {
      id: '/u/$localId/_staff/staff/'
      path: '/staff'
      fullPath: '/u/$localId/staff'
      preLoaderRoute: typeof ULocalIdStaffStaffIndexImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_acquirer/acquirer/agreements/$id': {
      id: '/u/$localId/_acquirer/acquirer/agreements/$id'
      path: '/acquirer/agreements/$id'
      fullPath: '/u/$localId/acquirer/agreements/$id'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerAgreementsIdImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/api-keys/new': {
      id: '/u/$localId/_acquirer/acquirer/api-keys/new'
      path: '/acquirer/api-keys/new'
      fullPath: '/u/$localId/acquirer/api-keys/new'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerApiKeysNewImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/audit-logs/$id': {
      id: '/u/$localId/_acquirer/acquirer/audit-logs/$id'
      path: '/acquirer/audit-logs/$id'
      fullPath: '/u/$localId/acquirer/audit-logs/$id'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerAuditLogsIdImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/card-authentications/$id': {
      id: '/u/$localId/_acquirer/acquirer/card-authentications/$id'
      path: '/acquirer/card-authentications/$id'
      fullPath: '/u/$localId/acquirer/card-authentications/$id'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerCardAuthenticationsIdImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/links/$id': {
      id: '/u/$localId/_acquirer/acquirer/links/$id'
      path: '/acquirer/links/$id'
      fullPath: '/u/$localId/acquirer/links/$id'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerLinksIdImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/merchants/$merchantId': {
      id: '/u/$localId/_acquirer/acquirer/merchants/$merchantId'
      path: '/acquirer/merchants/$merchantId'
      fullPath: '/u/$localId/acquirer/merchants/$merchantId'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerMerchantsMerchantIdImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/merchants/new': {
      id: '/u/$localId/_acquirer/acquirer/merchants/new'
      path: '/acquirer/merchants/new'
      fullPath: '/u/$localId/acquirer/merchants/new'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerMerchantsNewImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/orders/$id': {
      id: '/u/$localId/_acquirer/acquirer/orders/$id'
      path: '/acquirer/orders/$id'
      fullPath: '/u/$localId/acquirer/orders/$id'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerOrdersIdImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/users/new': {
      id: '/u/$localId/_acquirer/acquirer/users/new'
      path: '/acquirer/users/new'
      fullPath: '/u/$localId/acquirer/users/new'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerUsersNewImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_merchant/merchant/agreements/$id': {
      id: '/u/$localId/_merchant/merchant/agreements/$id'
      path: '/merchant/agreements/$id'
      fullPath: '/u/$localId/merchant/agreements/$id'
      preLoaderRoute: typeof ULocalIdMerchantMerchantAgreementsIdImport
      parentRoute: typeof ULocalIdMerchantImport
    }
    '/u/$localId/_merchant/merchant/api-keys/new': {
      id: '/u/$localId/_merchant/merchant/api-keys/new'
      path: '/merchant/api-keys/new'
      fullPath: '/u/$localId/merchant/api-keys/new'
      preLoaderRoute: typeof ULocalIdMerchantMerchantApiKeysNewImport
      parentRoute: typeof ULocalIdMerchantImport
    }
    '/u/$localId/_merchant/merchant/audit-logs/$id': {
      id: '/u/$localId/_merchant/merchant/audit-logs/$id'
      path: '/merchant/audit-logs/$id'
      fullPath: '/u/$localId/merchant/audit-logs/$id'
      preLoaderRoute: typeof ULocalIdMerchantMerchantAuditLogsIdImport
      parentRoute: typeof ULocalIdMerchantImport
    }
    '/u/$localId/_merchant/merchant/card-authentications/$id': {
      id: '/u/$localId/_merchant/merchant/card-authentications/$id'
      path: '/merchant/card-authentications/$id'
      fullPath: '/u/$localId/merchant/card-authentications/$id'
      preLoaderRoute: typeof ULocalIdMerchantMerchantCardAuthenticationsIdImport
      parentRoute: typeof ULocalIdMerchantImport
    }
    '/u/$localId/_merchant/merchant/links/$id': {
      id: '/u/$localId/_merchant/merchant/links/$id'
      path: '/merchant/links/$id'
      fullPath: '/u/$localId/merchant/links/$id'
      preLoaderRoute: typeof ULocalIdMerchantMerchantLinksIdImport
      parentRoute: typeof ULocalIdMerchantImport
    }
    '/u/$localId/_merchant/merchant/orders/$id': {
      id: '/u/$localId/_merchant/merchant/orders/$id'
      path: '/merchant/orders/$id'
      fullPath: '/u/$localId/merchant/orders/$id'
      preLoaderRoute: typeof ULocalIdMerchantMerchantOrdersIdImport
      parentRoute: typeof ULocalIdMerchantImport
    }
    '/u/$localId/_merchant/merchant/users/new': {
      id: '/u/$localId/_merchant/merchant/users/new'
      path: '/merchant/users/new'
      fullPath: '/u/$localId/merchant/users/new'
      preLoaderRoute: typeof ULocalIdMerchantMerchantUsersNewImport
      parentRoute: typeof ULocalIdMerchantImport
    }
    '/u/$localId/_staff/staff/acquirers/$acquirerId': {
      id: '/u/$localId/_staff/staff/acquirers/$acquirerId'
      path: '/staff/acquirers/$acquirerId'
      fullPath: '/u/$localId/staff/acquirers/$acquirerId'
      preLoaderRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/acquirers/new': {
      id: '/u/$localId/_staff/staff/acquirers/new'
      path: '/staff/acquirers/new'
      fullPath: '/u/$localId/staff/acquirers/new'
      preLoaderRoute: typeof ULocalIdStaffStaffAcquirersNewImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/agreements/$id': {
      id: '/u/$localId/_staff/staff/agreements/$id'
      path: '/staff/agreements/$id'
      fullPath: '/u/$localId/staff/agreements/$id'
      preLoaderRoute: typeof ULocalIdStaffStaffAgreementsIdImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/audit-logs/$id': {
      id: '/u/$localId/_staff/staff/audit-logs/$id'
      path: '/staff/audit-logs/$id'
      fullPath: '/u/$localId/staff/audit-logs/$id'
      preLoaderRoute: typeof ULocalIdStaffStaffAuditLogsIdImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/bench-users/new': {
      id: '/u/$localId/_staff/staff/bench-users/new'
      path: '/staff/bench-users/new'
      fullPath: '/u/$localId/staff/bench-users/new'
      preLoaderRoute: typeof ULocalIdStaffStaffBenchUsersNewImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/bins/import': {
      id: '/u/$localId/_staff/staff/bins/import'
      path: '/staff/bins/import'
      fullPath: '/u/$localId/staff/bins/import'
      preLoaderRoute: typeof ULocalIdStaffStaffBinsImportImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/card-authentications/$id': {
      id: '/u/$localId/_staff/staff/card-authentications/$id'
      path: '/staff/card-authentications/$id'
      fullPath: '/u/$localId/staff/card-authentications/$id'
      preLoaderRoute: typeof ULocalIdStaffStaffCardAuthenticationsIdImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/merchants/$merchantId': {
      id: '/u/$localId/_staff/staff/merchants/$merchantId'
      path: '/staff/merchants/$merchantId'
      fullPath: '/u/$localId/staff/merchants/$merchantId'
      preLoaderRoute: typeof ULocalIdStaffStaffMerchantsMerchantIdImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/orders/$id': {
      id: '/u/$localId/_staff/staff/orders/$id'
      path: '/staff/orders/$id'
      fullPath: '/u/$localId/staff/orders/$id'
      preLoaderRoute: typeof ULocalIdStaffStaffOrdersIdImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/tds-merchants/$id': {
      id: '/u/$localId/_staff/staff/tds-merchants/$id'
      path: '/staff/tds-merchants/$id'
      fullPath: '/u/$localId/staff/tds-merchants/$id'
      preLoaderRoute: typeof ULocalIdStaffStaffTdsMerchantsIdImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/users/new': {
      id: '/u/$localId/_staff/staff/users/new'
      path: '/staff/users/new'
      fullPath: '/u/$localId/staff/users/new'
      preLoaderRoute: typeof ULocalIdStaffStaffUsersNewImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_acquirer/acquirer/agreements/': {
      id: '/u/$localId/_acquirer/acquirer/agreements/'
      path: '/acquirer/agreements'
      fullPath: '/u/$localId/acquirer/agreements'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerAgreementsIndexImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/api-keys/': {
      id: '/u/$localId/_acquirer/acquirer/api-keys/'
      path: '/acquirer/api-keys'
      fullPath: '/u/$localId/acquirer/api-keys'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerApiKeysIndexImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/audit-logs/': {
      id: '/u/$localId/_acquirer/acquirer/audit-logs/'
      path: '/acquirer/audit-logs'
      fullPath: '/u/$localId/acquirer/audit-logs'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerAuditLogsIndexImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/card-authentications/': {
      id: '/u/$localId/_acquirer/acquirer/card-authentications/'
      path: '/acquirer/card-authentications'
      fullPath: '/u/$localId/acquirer/card-authentications'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerCardAuthenticationsIndexImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/eod-statements/': {
      id: '/u/$localId/_acquirer/acquirer/eod-statements/'
      path: '/acquirer/eod-statements'
      fullPath: '/u/$localId/acquirer/eod-statements'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerEodStatementsIndexImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/links/': {
      id: '/u/$localId/_acquirer/acquirer/links/'
      path: '/acquirer/links'
      fullPath: '/u/$localId/acquirer/links'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerLinksIndexImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/merchants/': {
      id: '/u/$localId/_acquirer/acquirer/merchants/'
      path: '/acquirer/merchants'
      fullPath: '/u/$localId/acquirer/merchants'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerMerchantsIndexImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/orders/': {
      id: '/u/$localId/_acquirer/acquirer/orders/'
      path: '/acquirer/orders'
      fullPath: '/u/$localId/acquirer/orders'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerOrdersIndexImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/payment-controls/': {
      id: '/u/$localId/_acquirer/acquirer/payment-controls/'
      path: '/acquirer/payment-controls'
      fullPath: '/u/$localId/acquirer/payment-controls'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerPaymentControlsIndexImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/settings/': {
      id: '/u/$localId/_acquirer/acquirer/settings/'
      path: '/acquirer/settings'
      fullPath: '/u/$localId/acquirer/settings'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerSettingsIndexImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/transactions/': {
      id: '/u/$localId/_acquirer/acquirer/transactions/'
      path: '/acquirer/transactions'
      fullPath: '/u/$localId/acquirer/transactions'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerTransactionsIndexImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/users/': {
      id: '/u/$localId/_acquirer/acquirer/users/'
      path: '/acquirer/users'
      fullPath: '/u/$localId/acquirer/users'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerUsersIndexImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_merchant/merchant/agreements/': {
      id: '/u/$localId/_merchant/merchant/agreements/'
      path: '/merchant/agreements'
      fullPath: '/u/$localId/merchant/agreements'
      preLoaderRoute: typeof ULocalIdMerchantMerchantAgreementsIndexImport
      parentRoute: typeof ULocalIdMerchantImport
    }
    '/u/$localId/_merchant/merchant/api-keys/': {
      id: '/u/$localId/_merchant/merchant/api-keys/'
      path: '/merchant/api-keys'
      fullPath: '/u/$localId/merchant/api-keys'
      preLoaderRoute: typeof ULocalIdMerchantMerchantApiKeysIndexImport
      parentRoute: typeof ULocalIdMerchantImport
    }
    '/u/$localId/_merchant/merchant/audit-logs/': {
      id: '/u/$localId/_merchant/merchant/audit-logs/'
      path: '/merchant/audit-logs'
      fullPath: '/u/$localId/merchant/audit-logs'
      preLoaderRoute: typeof ULocalIdMerchantMerchantAuditLogsIndexImport
      parentRoute: typeof ULocalIdMerchantImport
    }
    '/u/$localId/_merchant/merchant/card-authentications/': {
      id: '/u/$localId/_merchant/merchant/card-authentications/'
      path: '/merchant/card-authentications'
      fullPath: '/u/$localId/merchant/card-authentications'
      preLoaderRoute: typeof ULocalIdMerchantMerchantCardAuthenticationsIndexImport
      parentRoute: typeof ULocalIdMerchantImport
    }
    '/u/$localId/_merchant/merchant/links/': {
      id: '/u/$localId/_merchant/merchant/links/'
      path: '/merchant/links'
      fullPath: '/u/$localId/merchant/links'
      preLoaderRoute: typeof ULocalIdMerchantMerchantLinksIndexImport
      parentRoute: typeof ULocalIdMerchantImport
    }
    '/u/$localId/_merchant/merchant/orders/': {
      id: '/u/$localId/_merchant/merchant/orders/'
      path: '/merchant/orders'
      fullPath: '/u/$localId/merchant/orders'
      preLoaderRoute: typeof ULocalIdMerchantMerchantOrdersIndexImport
      parentRoute: typeof ULocalIdMerchantImport
    }
    '/u/$localId/_merchant/merchant/payment-controls/': {
      id: '/u/$localId/_merchant/merchant/payment-controls/'
      path: '/merchant/payment-controls'
      fullPath: '/u/$localId/merchant/payment-controls'
      preLoaderRoute: typeof ULocalIdMerchantMerchantPaymentControlsIndexImport
      parentRoute: typeof ULocalIdMerchantImport
    }
    '/u/$localId/_merchant/merchant/settings/': {
      id: '/u/$localId/_merchant/merchant/settings/'
      path: '/merchant/settings'
      fullPath: '/u/$localId/merchant/settings'
      preLoaderRoute: typeof ULocalIdMerchantMerchantSettingsIndexImport
      parentRoute: typeof ULocalIdMerchantImport
    }
    '/u/$localId/_merchant/merchant/transactions/': {
      id: '/u/$localId/_merchant/merchant/transactions/'
      path: '/merchant/transactions'
      fullPath: '/u/$localId/merchant/transactions'
      preLoaderRoute: typeof ULocalIdMerchantMerchantTransactionsIndexImport
      parentRoute: typeof ULocalIdMerchantImport
    }
    '/u/$localId/_merchant/merchant/users/': {
      id: '/u/$localId/_merchant/merchant/users/'
      path: '/merchant/users'
      fullPath: '/u/$localId/merchant/users'
      preLoaderRoute: typeof ULocalIdMerchantMerchantUsersIndexImport
      parentRoute: typeof ULocalIdMerchantImport
    }
    '/u/$localId/_staff/staff/acquirers/': {
      id: '/u/$localId/_staff/staff/acquirers/'
      path: '/staff/acquirers'
      fullPath: '/u/$localId/staff/acquirers'
      preLoaderRoute: typeof ULocalIdStaffStaffAcquirersIndexImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/agreements/': {
      id: '/u/$localId/_staff/staff/agreements/'
      path: '/staff/agreements'
      fullPath: '/u/$localId/staff/agreements'
      preLoaderRoute: typeof ULocalIdStaffStaffAgreementsIndexImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/audit-logs/': {
      id: '/u/$localId/_staff/staff/audit-logs/'
      path: '/staff/audit-logs'
      fullPath: '/u/$localId/staff/audit-logs'
      preLoaderRoute: typeof ULocalIdStaffStaffAuditLogsIndexImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/bench-users/': {
      id: '/u/$localId/_staff/staff/bench-users/'
      path: '/staff/bench-users'
      fullPath: '/u/$localId/staff/bench-users'
      preLoaderRoute: typeof ULocalIdStaffStaffBenchUsersIndexImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/card-authentications/': {
      id: '/u/$localId/_staff/staff/card-authentications/'
      path: '/staff/card-authentications'
      fullPath: '/u/$localId/staff/card-authentications'
      preLoaderRoute: typeof ULocalIdStaffStaffCardAuthenticationsIndexImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/merchants/': {
      id: '/u/$localId/_staff/staff/merchants/'
      path: '/staff/merchants'
      fullPath: '/u/$localId/staff/merchants'
      preLoaderRoute: typeof ULocalIdStaffStaffMerchantsIndexImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/orders/': {
      id: '/u/$localId/_staff/staff/orders/'
      path: '/staff/orders'
      fullPath: '/u/$localId/staff/orders'
      preLoaderRoute: typeof ULocalIdStaffStaffOrdersIndexImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/settings/': {
      id: '/u/$localId/_staff/staff/settings/'
      path: '/staff/settings'
      fullPath: '/u/$localId/staff/settings'
      preLoaderRoute: typeof ULocalIdStaffStaffSettingsIndexImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/tds-merchants/': {
      id: '/u/$localId/_staff/staff/tds-merchants/'
      path: '/staff/tds-merchants'
      fullPath: '/u/$localId/staff/tds-merchants'
      preLoaderRoute: typeof ULocalIdStaffStaffTdsMerchantsIndexImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/transactions/': {
      id: '/u/$localId/_staff/staff/transactions/'
      path: '/staff/transactions'
      fullPath: '/u/$localId/staff/transactions'
      preLoaderRoute: typeof ULocalIdStaffStaffTransactionsIndexImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/users/': {
      id: '/u/$localId/_staff/staff/users/'
      path: '/staff/users'
      fullPath: '/u/$localId/staff/users'
      preLoaderRoute: typeof ULocalIdStaffStaffUsersIndexImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_acquirer/acquirer/agreements/$id/api-response': {
      id: '/u/$localId/_acquirer/acquirer/agreements/$id/api-response'
      path: '/api-response'
      fullPath: '/u/$localId/acquirer/agreements/$id/api-response'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerAgreementsIdApiResponseImport
      parentRoute: typeof ULocalIdAcquirerAcquirerAgreementsIdImport
    }
    '/u/$localId/_acquirer/acquirer/agreements/$id/orders': {
      id: '/u/$localId/_acquirer/acquirer/agreements/$id/orders'
      path: '/orders'
      fullPath: '/u/$localId/acquirer/agreements/$id/orders'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerAgreementsIdOrdersImport
      parentRoute: typeof ULocalIdAcquirerAcquirerAgreementsIdImport
    }
    '/u/$localId/_acquirer/acquirer/api-keys/$id/edit': {
      id: '/u/$localId/_acquirer/acquirer/api-keys/$id/edit'
      path: '/acquirer/api-keys/$id/edit'
      fullPath: '/u/$localId/acquirer/api-keys/$id/edit'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerApiKeysIdEditImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/card-authentications/$id/apiResponse': {
      id: '/u/$localId/_acquirer/acquirer/card-authentications/$id/apiResponse'
      path: '/apiResponse'
      fullPath: '/u/$localId/acquirer/card-authentications/$id/apiResponse'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerCardAuthenticationsIdApiResponseImport
      parentRoute: typeof ULocalIdAcquirerAcquirerCardAuthenticationsIdImport
    }
    '/u/$localId/_acquirer/acquirer/card-authentications/$id/auth': {
      id: '/u/$localId/_acquirer/acquirer/card-authentications/$id/auth'
      path: '/auth'
      fullPath: '/u/$localId/acquirer/card-authentications/$id/auth'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerCardAuthenticationsIdAuthImport
      parentRoute: typeof ULocalIdAcquirerAcquirerCardAuthenticationsIdImport
    }
    '/u/$localId/_acquirer/acquirer/card-authentications/$id/merchant': {
      id: '/u/$localId/_acquirer/acquirer/card-authentications/$id/merchant'
      path: '/merchant'
      fullPath: '/u/$localId/acquirer/card-authentications/$id/merchant'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerCardAuthenticationsIdMerchantImport
      parentRoute: typeof ULocalIdAcquirerAcquirerCardAuthenticationsIdImport
    }
    '/u/$localId/_acquirer/acquirer/merchants/$merchantId/card-authentications': {
      id: '/u/$localId/_acquirer/acquirer/merchants/$merchantId/card-authentications'
      path: '/card-authentications'
      fullPath: '/u/$localId/acquirer/merchants/$merchantId/card-authentications'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerMerchantsMerchantIdCardAuthenticationsImport
      parentRoute: typeof ULocalIdAcquirerAcquirerMerchantsMerchantIdImport
    }
    '/u/$localId/_acquirer/acquirer/merchants/$merchantId/links': {
      id: '/u/$localId/_acquirer/acquirer/merchants/$merchantId/links'
      path: '/links'
      fullPath: '/u/$localId/acquirer/merchants/$merchantId/links'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerMerchantsMerchantIdLinksImport
      parentRoute: typeof ULocalIdAcquirerAcquirerMerchantsMerchantIdImport
    }
    '/u/$localId/_acquirer/acquirer/merchants/$merchantId/orders': {
      id: '/u/$localId/_acquirer/acquirer/merchants/$merchantId/orders'
      path: '/orders'
      fullPath: '/u/$localId/acquirer/merchants/$merchantId/orders'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerMerchantsMerchantIdOrdersImport
      parentRoute: typeof ULocalIdAcquirerAcquirerMerchantsMerchantIdImport
    }
    '/u/$localId/_acquirer/acquirer/merchants/$merchantId/transactions': {
      id: '/u/$localId/_acquirer/acquirer/merchants/$merchantId/transactions'
      path: '/transactions'
      fullPath: '/u/$localId/acquirer/merchants/$merchantId/transactions'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerMerchantsMerchantIdTransactionsImport
      parentRoute: typeof ULocalIdAcquirerAcquirerMerchantsMerchantIdImport
    }
    '/u/$localId/_acquirer/acquirer/merchants/$merchantId/users': {
      id: '/u/$localId/_acquirer/acquirer/merchants/$merchantId/users'
      path: '/users'
      fullPath: '/u/$localId/acquirer/merchants/$merchantId/users'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerMerchantsMerchantIdUsersImport
      parentRoute: typeof ULocalIdAcquirerAcquirerMerchantsMerchantIdImport
    }
    '/u/$localId/_acquirer/acquirer/merchants/$merchantId/edit': {
      id: '/u/$localId/_acquirer/acquirer/merchants/$merchantId/edit'
      path: '/acquirer/merchants/$merchantId/edit'
      fullPath: '/u/$localId/acquirer/merchants/$merchantId/edit'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerMerchantsMerchantIdEditImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/orders/$id/agreement': {
      id: '/u/$localId/_acquirer/acquirer/orders/$id/agreement'
      path: '/agreement'
      fullPath: '/u/$localId/acquirer/orders/$id/agreement'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerOrdersIdAgreementImport
      parentRoute: typeof ULocalIdAcquirerAcquirerOrdersIdImport
    }
    '/u/$localId/_acquirer/acquirer/orders/$id/apiResponse': {
      id: '/u/$localId/_acquirer/acquirer/orders/$id/apiResponse'
      path: '/apiResponse'
      fullPath: '/u/$localId/acquirer/orders/$id/apiResponse'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerOrdersIdApiResponseImport
      parentRoute: typeof ULocalIdAcquirerAcquirerOrdersIdImport
    }
    '/u/$localId/_acquirer/acquirer/orders/$id/merchant': {
      id: '/u/$localId/_acquirer/acquirer/orders/$id/merchant'
      path: '/merchant'
      fullPath: '/u/$localId/acquirer/orders/$id/merchant'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerOrdersIdMerchantImport
      parentRoute: typeof ULocalIdAcquirerAcquirerOrdersIdImport
    }
    '/u/$localId/_acquirer/acquirer/orders/$id/source': {
      id: '/u/$localId/_acquirer/acquirer/orders/$id/source'
      path: '/source'
      fullPath: '/u/$localId/acquirer/orders/$id/source'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerOrdersIdSourceImport
      parentRoute: typeof ULocalIdAcquirerAcquirerOrdersIdImport
    }
    '/u/$localId/_acquirer/acquirer/orders/$id/subMerchant': {
      id: '/u/$localId/_acquirer/acquirer/orders/$id/subMerchant'
      path: '/subMerchant'
      fullPath: '/u/$localId/acquirer/orders/$id/subMerchant'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerOrdersIdSubMerchantImport
      parentRoute: typeof ULocalIdAcquirerAcquirerOrdersIdImport
    }
    '/u/$localId/_acquirer/acquirer/orders/$id/transactions': {
      id: '/u/$localId/_acquirer/acquirer/orders/$id/transactions'
      path: '/transactions'
      fullPath: '/u/$localId/acquirer/orders/$id/transactions'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerOrdersIdTransactionsImport
      parentRoute: typeof ULocalIdAcquirerAcquirerOrdersIdImport
    }
    '/u/$localId/_acquirer/acquirer/payment-controls/$type/$id': {
      id: '/u/$localId/_acquirer/acquirer/payment-controls/$type/$id'
      path: '/acquirer/payment-controls/$type/$id'
      fullPath: '/u/$localId/acquirer/payment-controls/$type/$id'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerPaymentControlsTypeIdImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/users/$id/edit': {
      id: '/u/$localId/_acquirer/acquirer/users/$id/edit'
      path: '/acquirer/users/$id/edit'
      fullPath: '/u/$localId/acquirer/users/$id/edit'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerUsersIdEditImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_merchant/merchant/agreements/$id/api-response': {
      id: '/u/$localId/_merchant/merchant/agreements/$id/api-response'
      path: '/api-response'
      fullPath: '/u/$localId/merchant/agreements/$id/api-response'
      preLoaderRoute: typeof ULocalIdMerchantMerchantAgreementsIdApiResponseImport
      parentRoute: typeof ULocalIdMerchantMerchantAgreementsIdImport
    }
    '/u/$localId/_merchant/merchant/agreements/$id/orders': {
      id: '/u/$localId/_merchant/merchant/agreements/$id/orders'
      path: '/orders'
      fullPath: '/u/$localId/merchant/agreements/$id/orders'
      preLoaderRoute: typeof ULocalIdMerchantMerchantAgreementsIdOrdersImport
      parentRoute: typeof ULocalIdMerchantMerchantAgreementsIdImport
    }
    '/u/$localId/_merchant/merchant/api-keys/$id/edit': {
      id: '/u/$localId/_merchant/merchant/api-keys/$id/edit'
      path: '/merchant/api-keys/$id/edit'
      fullPath: '/u/$localId/merchant/api-keys/$id/edit'
      preLoaderRoute: typeof ULocalIdMerchantMerchantApiKeysIdEditImport
      parentRoute: typeof ULocalIdMerchantImport
    }
    '/u/$localId/_merchant/merchant/card-authentications/$id/apiResponse': {
      id: '/u/$localId/_merchant/merchant/card-authentications/$id/apiResponse'
      path: '/apiResponse'
      fullPath: '/u/$localId/merchant/card-authentications/$id/apiResponse'
      preLoaderRoute: typeof ULocalIdMerchantMerchantCardAuthenticationsIdApiResponseImport
      parentRoute: typeof ULocalIdMerchantMerchantCardAuthenticationsIdImport
    }
    '/u/$localId/_merchant/merchant/card-authentications/$id/auth': {
      id: '/u/$localId/_merchant/merchant/card-authentications/$id/auth'
      path: '/auth'
      fullPath: '/u/$localId/merchant/card-authentications/$id/auth'
      preLoaderRoute: typeof ULocalIdMerchantMerchantCardAuthenticationsIdAuthImport
      parentRoute: typeof ULocalIdMerchantMerchantCardAuthenticationsIdImport
    }
    '/u/$localId/_merchant/merchant/card-authentications/$id/merchant': {
      id: '/u/$localId/_merchant/merchant/card-authentications/$id/merchant'
      path: '/merchant'
      fullPath: '/u/$localId/merchant/card-authentications/$id/merchant'
      preLoaderRoute: typeof ULocalIdMerchantMerchantCardAuthenticationsIdMerchantImport
      parentRoute: typeof ULocalIdMerchantMerchantCardAuthenticationsIdImport
    }
    '/u/$localId/_merchant/merchant/orders/$id/agreement': {
      id: '/u/$localId/_merchant/merchant/orders/$id/agreement'
      path: '/agreement'
      fullPath: '/u/$localId/merchant/orders/$id/agreement'
      preLoaderRoute: typeof ULocalIdMerchantMerchantOrdersIdAgreementImport
      parentRoute: typeof ULocalIdMerchantMerchantOrdersIdImport
    }
    '/u/$localId/_merchant/merchant/orders/$id/apiResponse': {
      id: '/u/$localId/_merchant/merchant/orders/$id/apiResponse'
      path: '/apiResponse'
      fullPath: '/u/$localId/merchant/orders/$id/apiResponse'
      preLoaderRoute: typeof ULocalIdMerchantMerchantOrdersIdApiResponseImport
      parentRoute: typeof ULocalIdMerchantMerchantOrdersIdImport
    }
    '/u/$localId/_merchant/merchant/orders/$id/merchant': {
      id: '/u/$localId/_merchant/merchant/orders/$id/merchant'
      path: '/merchant'
      fullPath: '/u/$localId/merchant/orders/$id/merchant'
      preLoaderRoute: typeof ULocalIdMerchantMerchantOrdersIdMerchantImport
      parentRoute: typeof ULocalIdMerchantMerchantOrdersIdImport
    }
    '/u/$localId/_merchant/merchant/orders/$id/source': {
      id: '/u/$localId/_merchant/merchant/orders/$id/source'
      path: '/source'
      fullPath: '/u/$localId/merchant/orders/$id/source'
      preLoaderRoute: typeof ULocalIdMerchantMerchantOrdersIdSourceImport
      parentRoute: typeof ULocalIdMerchantMerchantOrdersIdImport
    }
    '/u/$localId/_merchant/merchant/orders/$id/subMerchant': {
      id: '/u/$localId/_merchant/merchant/orders/$id/subMerchant'
      path: '/subMerchant'
      fullPath: '/u/$localId/merchant/orders/$id/subMerchant'
      preLoaderRoute: typeof ULocalIdMerchantMerchantOrdersIdSubMerchantImport
      parentRoute: typeof ULocalIdMerchantMerchantOrdersIdImport
    }
    '/u/$localId/_merchant/merchant/orders/$id/transactions': {
      id: '/u/$localId/_merchant/merchant/orders/$id/transactions'
      path: '/transactions'
      fullPath: '/u/$localId/merchant/orders/$id/transactions'
      preLoaderRoute: typeof ULocalIdMerchantMerchantOrdersIdTransactionsImport
      parentRoute: typeof ULocalIdMerchantMerchantOrdersIdImport
    }
    '/u/$localId/_merchant/merchant/payment-controls/$type/$id': {
      id: '/u/$localId/_merchant/merchant/payment-controls/$type/$id'
      path: '/merchant/payment-controls/$type/$id'
      fullPath: '/u/$localId/merchant/payment-controls/$type/$id'
      preLoaderRoute: typeof ULocalIdMerchantMerchantPaymentControlsTypeIdImport
      parentRoute: typeof ULocalIdMerchantImport
    }
    '/u/$localId/_merchant/merchant/users/$id/edit': {
      id: '/u/$localId/_merchant/merchant/users/$id/edit'
      path: '/merchant/users/$id/edit'
      fullPath: '/u/$localId/merchant/users/$id/edit'
      preLoaderRoute: typeof ULocalIdMerchantMerchantUsersIdEditImport
      parentRoute: typeof ULocalIdMerchantImport
    }
    '/u/$localId/_staff/staff/acquirers/$acquirerId/api-keys': {
      id: '/u/$localId/_staff/staff/acquirers/$acquirerId/api-keys'
      path: '/api-keys'
      fullPath: '/u/$localId/staff/acquirers/$acquirerId/api-keys'
      preLoaderRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdApiKeysImport
      parentRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdImport
    }
    '/u/$localId/_staff/staff/acquirers/$acquirerId/links': {
      id: '/u/$localId/_staff/staff/acquirers/$acquirerId/links'
      path: '/links'
      fullPath: '/u/$localId/staff/acquirers/$acquirerId/links'
      preLoaderRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdLinksImport
      parentRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdImport
    }
    '/u/$localId/_staff/staff/acquirers/$acquirerId/merchants': {
      id: '/u/$localId/_staff/staff/acquirers/$acquirerId/merchants'
      path: '/merchants'
      fullPath: '/u/$localId/staff/acquirers/$acquirerId/merchants'
      preLoaderRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdMerchantsImport
      parentRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdImport
    }
    '/u/$localId/_staff/staff/acquirers/$acquirerId/orders': {
      id: '/u/$localId/_staff/staff/acquirers/$acquirerId/orders'
      path: '/orders'
      fullPath: '/u/$localId/staff/acquirers/$acquirerId/orders'
      preLoaderRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdOrdersImport
      parentRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdImport
    }
    '/u/$localId/_staff/staff/acquirers/$acquirerId/transactions': {
      id: '/u/$localId/_staff/staff/acquirers/$acquirerId/transactions'
      path: '/transactions'
      fullPath: '/u/$localId/staff/acquirers/$acquirerId/transactions'
      preLoaderRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdTransactionsImport
      parentRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdImport
    }
    '/u/$localId/_staff/staff/acquirers/$acquirerId/users': {
      id: '/u/$localId/_staff/staff/acquirers/$acquirerId/users'
      path: '/users'
      fullPath: '/u/$localId/staff/acquirers/$acquirerId/users'
      preLoaderRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdUsersImport
      parentRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdImport
    }
    '/u/$localId/_staff/staff/acquirers/$acquirerId/edit': {
      id: '/u/$localId/_staff/staff/acquirers/$acquirerId/edit'
      path: '/staff/acquirers/$acquirerId/edit'
      fullPath: '/u/$localId/staff/acquirers/$acquirerId/edit'
      preLoaderRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdEditImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/agreements/$id/api-response': {
      id: '/u/$localId/_staff/staff/agreements/$id/api-response'
      path: '/api-response'
      fullPath: '/u/$localId/staff/agreements/$id/api-response'
      preLoaderRoute: typeof ULocalIdStaffStaffAgreementsIdApiResponseImport
      parentRoute: typeof ULocalIdStaffStaffAgreementsIdImport
    }
    '/u/$localId/_staff/staff/agreements/$id/orders': {
      id: '/u/$localId/_staff/staff/agreements/$id/orders'
      path: '/orders'
      fullPath: '/u/$localId/staff/agreements/$id/orders'
      preLoaderRoute: typeof ULocalIdStaffStaffAgreementsIdOrdersImport
      parentRoute: typeof ULocalIdStaffStaffAgreementsIdImport
    }
    '/u/$localId/_staff/staff/bench-users/$id/edit': {
      id: '/u/$localId/_staff/staff/bench-users/$id/edit'
      path: '/staff/bench-users/$id/edit'
      fullPath: '/u/$localId/staff/bench-users/$id/edit'
      preLoaderRoute: typeof ULocalIdStaffStaffBenchUsersIdEditImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/card-authentications/$id/apiResponse': {
      id: '/u/$localId/_staff/staff/card-authentications/$id/apiResponse'
      path: '/apiResponse'
      fullPath: '/u/$localId/staff/card-authentications/$id/apiResponse'
      preLoaderRoute: typeof ULocalIdStaffStaffCardAuthenticationsIdApiResponseImport
      parentRoute: typeof ULocalIdStaffStaffCardAuthenticationsIdImport
    }
    '/u/$localId/_staff/staff/card-authentications/$id/auth': {
      id: '/u/$localId/_staff/staff/card-authentications/$id/auth'
      path: '/auth'
      fullPath: '/u/$localId/staff/card-authentications/$id/auth'
      preLoaderRoute: typeof ULocalIdStaffStaffCardAuthenticationsIdAuthImport
      parentRoute: typeof ULocalIdStaffStaffCardAuthenticationsIdImport
    }
    '/u/$localId/_staff/staff/card-authentications/$id/merchant': {
      id: '/u/$localId/_staff/staff/card-authentications/$id/merchant'
      path: '/merchant'
      fullPath: '/u/$localId/staff/card-authentications/$id/merchant'
      preLoaderRoute: typeof ULocalIdStaffStaffCardAuthenticationsIdMerchantImport
      parentRoute: typeof ULocalIdStaffStaffCardAuthenticationsIdImport
    }
    '/u/$localId/_staff/staff/merchants/$merchantId/api-keys': {
      id: '/u/$localId/_staff/staff/merchants/$merchantId/api-keys'
      path: '/api-keys'
      fullPath: '/u/$localId/staff/merchants/$merchantId/api-keys'
      preLoaderRoute: typeof ULocalIdStaffStaffMerchantsMerchantIdApiKeysImport
      parentRoute: typeof ULocalIdStaffStaffMerchantsMerchantIdImport
    }
    '/u/$localId/_staff/staff/merchants/$merchantId/links': {
      id: '/u/$localId/_staff/staff/merchants/$merchantId/links'
      path: '/links'
      fullPath: '/u/$localId/staff/merchants/$merchantId/links'
      preLoaderRoute: typeof ULocalIdStaffStaffMerchantsMerchantIdLinksImport
      parentRoute: typeof ULocalIdStaffStaffMerchantsMerchantIdImport
    }
    '/u/$localId/_staff/staff/merchants/$merchantId/orders': {
      id: '/u/$localId/_staff/staff/merchants/$merchantId/orders'
      path: '/orders'
      fullPath: '/u/$localId/staff/merchants/$merchantId/orders'
      preLoaderRoute: typeof ULocalIdStaffStaffMerchantsMerchantIdOrdersImport
      parentRoute: typeof ULocalIdStaffStaffMerchantsMerchantIdImport
    }
    '/u/$localId/_staff/staff/merchants/$merchantId/transactions': {
      id: '/u/$localId/_staff/staff/merchants/$merchantId/transactions'
      path: '/transactions'
      fullPath: '/u/$localId/staff/merchants/$merchantId/transactions'
      preLoaderRoute: typeof ULocalIdStaffStaffMerchantsMerchantIdTransactionsImport
      parentRoute: typeof ULocalIdStaffStaffMerchantsMerchantIdImport
    }
    '/u/$localId/_staff/staff/merchants/$merchantId/users': {
      id: '/u/$localId/_staff/staff/merchants/$merchantId/users'
      path: '/users'
      fullPath: '/u/$localId/staff/merchants/$merchantId/users'
      preLoaderRoute: typeof ULocalIdStaffStaffMerchantsMerchantIdUsersImport
      parentRoute: typeof ULocalIdStaffStaffMerchantsMerchantIdImport
    }
    '/u/$localId/_staff/staff/merchants/$merchantId/edit': {
      id: '/u/$localId/_staff/staff/merchants/$merchantId/edit'
      path: '/staff/merchants/$merchantId/edit'
      fullPath: '/u/$localId/staff/merchants/$merchantId/edit'
      preLoaderRoute: typeof ULocalIdStaffStaffMerchantsMerchantIdEditImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/orders/$id/agreement': {
      id: '/u/$localId/_staff/staff/orders/$id/agreement'
      path: '/agreement'
      fullPath: '/u/$localId/staff/orders/$id/agreement'
      preLoaderRoute: typeof ULocalIdStaffStaffOrdersIdAgreementImport
      parentRoute: typeof ULocalIdStaffStaffOrdersIdImport
    }
    '/u/$localId/_staff/staff/orders/$id/apiResponse': {
      id: '/u/$localId/_staff/staff/orders/$id/apiResponse'
      path: '/apiResponse'
      fullPath: '/u/$localId/staff/orders/$id/apiResponse'
      preLoaderRoute: typeof ULocalIdStaffStaffOrdersIdApiResponseImport
      parentRoute: typeof ULocalIdStaffStaffOrdersIdImport
    }
    '/u/$localId/_staff/staff/orders/$id/merchant': {
      id: '/u/$localId/_staff/staff/orders/$id/merchant'
      path: '/merchant'
      fullPath: '/u/$localId/staff/orders/$id/merchant'
      preLoaderRoute: typeof ULocalIdStaffStaffOrdersIdMerchantImport
      parentRoute: typeof ULocalIdStaffStaffOrdersIdImport
    }
    '/u/$localId/_staff/staff/orders/$id/source': {
      id: '/u/$localId/_staff/staff/orders/$id/source'
      path: '/source'
      fullPath: '/u/$localId/staff/orders/$id/source'
      preLoaderRoute: typeof ULocalIdStaffStaffOrdersIdSourceImport
      parentRoute: typeof ULocalIdStaffStaffOrdersIdImport
    }
    '/u/$localId/_staff/staff/orders/$id/subMerchant': {
      id: '/u/$localId/_staff/staff/orders/$id/subMerchant'
      path: '/subMerchant'
      fullPath: '/u/$localId/staff/orders/$id/subMerchant'
      preLoaderRoute: typeof ULocalIdStaffStaffOrdersIdSubMerchantImport
      parentRoute: typeof ULocalIdStaffStaffOrdersIdImport
    }
    '/u/$localId/_staff/staff/orders/$id/transactions': {
      id: '/u/$localId/_staff/staff/orders/$id/transactions'
      path: '/transactions'
      fullPath: '/u/$localId/staff/orders/$id/transactions'
      preLoaderRoute: typeof ULocalIdStaffStaffOrdersIdTransactionsImport
      parentRoute: typeof ULocalIdStaffStaffOrdersIdImport
    }
    '/u/$localId/_staff/staff/users/$id/edit': {
      id: '/u/$localId/_staff/staff/users/$id/edit'
      path: '/staff/users/$id/edit'
      fullPath: '/u/$localId/staff/users/$id/edit'
      preLoaderRoute: typeof ULocalIdStaffStaffUsersIdEditImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_acquirer/acquirer/api-keys/$id/': {
      id: '/u/$localId/_acquirer/acquirer/api-keys/$id/'
      path: '/acquirer/api-keys/$id'
      fullPath: '/u/$localId/acquirer/api-keys/$id'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerApiKeysIdIndexImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/payment-controls/$type/': {
      id: '/u/$localId/_acquirer/acquirer/payment-controls/$type/'
      path: '/acquirer/payment-controls/$type'
      fullPath: '/u/$localId/acquirer/payment-controls/$type'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerPaymentControlsTypeIndexImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/users/$id/': {
      id: '/u/$localId/_acquirer/acquirer/users/$id/'
      path: '/acquirer/users/$id'
      fullPath: '/u/$localId/acquirer/users/$id'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerUsersIdIndexImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_merchant/merchant/api-keys/$id/': {
      id: '/u/$localId/_merchant/merchant/api-keys/$id/'
      path: '/merchant/api-keys/$id'
      fullPath: '/u/$localId/merchant/api-keys/$id'
      preLoaderRoute: typeof ULocalIdMerchantMerchantApiKeysIdIndexImport
      parentRoute: typeof ULocalIdMerchantImport
    }
    '/u/$localId/_merchant/merchant/payment-controls/$type/': {
      id: '/u/$localId/_merchant/merchant/payment-controls/$type/'
      path: '/merchant/payment-controls/$type'
      fullPath: '/u/$localId/merchant/payment-controls/$type'
      preLoaderRoute: typeof ULocalIdMerchantMerchantPaymentControlsTypeIndexImport
      parentRoute: typeof ULocalIdMerchantImport
    }
    '/u/$localId/_merchant/merchant/users/$id/': {
      id: '/u/$localId/_merchant/merchant/users/$id/'
      path: '/merchant/users/$id'
      fullPath: '/u/$localId/merchant/users/$id'
      preLoaderRoute: typeof ULocalIdMerchantMerchantUsersIdIndexImport
      parentRoute: typeof ULocalIdMerchantImport
    }
    '/u/$localId/_staff/staff/users/$id/': {
      id: '/u/$localId/_staff/staff/users/$id/'
      path: '/staff/users/$id'
      fullPath: '/u/$localId/staff/users/$id'
      preLoaderRoute: typeof ULocalIdStaffStaffUsersIdIndexImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_acquirer/acquirer/merchants/$merchantId/links/new': {
      id: '/u/$localId/_acquirer/acquirer/merchants/$merchantId/links/new'
      path: '/acquirer/merchants/$merchantId/links/new'
      fullPath: '/u/$localId/acquirer/merchants/$merchantId/links/new'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerMerchantsMerchantIdLinksNewImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/merchants/$merchantId/users/new': {
      id: '/u/$localId/_acquirer/acquirer/merchants/$merchantId/users/new'
      path: '/acquirer/merchants/$merchantId/users/new'
      fullPath: '/u/$localId/acquirer/merchants/$merchantId/users/new'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerMerchantsMerchantIdUsersNewImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_staff/staff/acquirers/$acquirerId/api-keys/new': {
      id: '/u/$localId/_staff/staff/acquirers/$acquirerId/api-keys/new'
      path: '/staff/acquirers/$acquirerId/api-keys/new'
      fullPath: '/u/$localId/staff/acquirers/$acquirerId/api-keys/new'
      preLoaderRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdApiKeysNewImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/acquirers/$acquirerId/links/new': {
      id: '/u/$localId/_staff/staff/acquirers/$acquirerId/links/new'
      path: '/staff/acquirers/$acquirerId/links/new'
      fullPath: '/u/$localId/staff/acquirers/$acquirerId/links/new'
      preLoaderRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdLinksNewImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/acquirers/$acquirerId/merchants/new': {
      id: '/u/$localId/_staff/staff/acquirers/$acquirerId/merchants/new'
      path: '/staff/acquirers/$acquirerId/merchants/new'
      fullPath: '/u/$localId/staff/acquirers/$acquirerId/merchants/new'
      preLoaderRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdMerchantsNewImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/acquirers/$acquirerId/users/new': {
      id: '/u/$localId/_staff/staff/acquirers/$acquirerId/users/new'
      path: '/staff/acquirers/$acquirerId/users/new'
      fullPath: '/u/$localId/staff/acquirers/$acquirerId/users/new'
      preLoaderRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdUsersNewImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/merchants/$merchantId/api-keys/new': {
      id: '/u/$localId/_staff/staff/merchants/$merchantId/api-keys/new'
      path: '/staff/merchants/$merchantId/api-keys/new'
      fullPath: '/u/$localId/staff/merchants/$merchantId/api-keys/new'
      preLoaderRoute: typeof ULocalIdStaffStaffMerchantsMerchantIdApiKeysNewImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/merchants/$merchantId/links/new': {
      id: '/u/$localId/_staff/staff/merchants/$merchantId/links/new'
      path: '/staff/merchants/$merchantId/links/new'
      fullPath: '/u/$localId/staff/merchants/$merchantId/links/new'
      preLoaderRoute: typeof ULocalIdStaffStaffMerchantsMerchantIdLinksNewImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/merchants/$merchantId/users/new': {
      id: '/u/$localId/_staff/staff/merchants/$merchantId/users/new'
      path: '/staff/merchants/$merchantId/users/new'
      fullPath: '/u/$localId/staff/merchants/$merchantId/users/new'
      preLoaderRoute: typeof ULocalIdStaffStaffMerchantsMerchantIdUsersNewImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_acquirer/acquirer/merchants/$merchantId/payment-controls/': {
      id: '/u/$localId/_acquirer/acquirer/merchants/$merchantId/payment-controls/'
      path: '/payment-controls'
      fullPath: '/u/$localId/acquirer/merchants/$merchantId/payment-controls'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerMerchantsMerchantIdPaymentControlsIndexImport
      parentRoute: typeof ULocalIdAcquirerAcquirerMerchantsMerchantIdImport
    }
    '/u/$localId/_staff/staff/acquirers/$acquirerId/payment-controls/': {
      id: '/u/$localId/_staff/staff/acquirers/$acquirerId/payment-controls/'
      path: '/payment-controls'
      fullPath: '/u/$localId/staff/acquirers/$acquirerId/payment-controls'
      preLoaderRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdPaymentControlsIndexImport
      parentRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdImport
    }
    '/u/$localId/_staff/staff/merchants/$merchantId/payment-controls/': {
      id: '/u/$localId/_staff/staff/merchants/$merchantId/payment-controls/'
      path: '/payment-controls'
      fullPath: '/u/$localId/staff/merchants/$merchantId/payment-controls'
      preLoaderRoute: typeof ULocalIdStaffStaffMerchantsMerchantIdPaymentControlsIndexImport
      parentRoute: typeof ULocalIdStaffStaffMerchantsMerchantIdImport
    }
    '/u/$localId/_acquirer/acquirer/merchants/$merchantId/links/$id/edit': {
      id: '/u/$localId/_acquirer/acquirer/merchants/$merchantId/links/$id/edit'
      path: '/acquirer/merchants/$merchantId/links/$id/edit'
      fullPath: '/u/$localId/acquirer/merchants/$merchantId/links/$id/edit'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerMerchantsMerchantIdLinksIdEditImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/merchants/$merchantId/payment-controls/$type/$id': {
      id: '/u/$localId/_acquirer/acquirer/merchants/$merchantId/payment-controls/$type/$id'
      path: '/acquirer/merchants/$merchantId/payment-controls/$type/$id'
      fullPath: '/u/$localId/acquirer/merchants/$merchantId/payment-controls/$type/$id'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerMerchantsMerchantIdPaymentControlsTypeIdImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/merchants/$merchantId/users/$id/edit': {
      id: '/u/$localId/_acquirer/acquirer/merchants/$merchantId/users/$id/edit'
      path: '/acquirer/merchants/$merchantId/users/$id/edit'
      fullPath: '/u/$localId/acquirer/merchants/$merchantId/users/$id/edit'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerMerchantsMerchantIdUsersIdEditImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_staff/staff/acquirers/$acquirerId/api-keys/$id/edit': {
      id: '/u/$localId/_staff/staff/acquirers/$acquirerId/api-keys/$id/edit'
      path: '/staff/acquirers/$acquirerId/api-keys/$id/edit'
      fullPath: '/u/$localId/staff/acquirers/$acquirerId/api-keys/$id/edit'
      preLoaderRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdApiKeysIdEditImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/acquirers/$acquirerId/links/$id/edit': {
      id: '/u/$localId/_staff/staff/acquirers/$acquirerId/links/$id/edit'
      path: '/staff/acquirers/$acquirerId/links/$id/edit'
      fullPath: '/u/$localId/staff/acquirers/$acquirerId/links/$id/edit'
      preLoaderRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdLinksIdEditImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/acquirers/$acquirerId/payment-controls/$type/$id': {
      id: '/u/$localId/_staff/staff/acquirers/$acquirerId/payment-controls/$type/$id'
      path: '/staff/acquirers/$acquirerId/payment-controls/$type/$id'
      fullPath: '/u/$localId/staff/acquirers/$acquirerId/payment-controls/$type/$id'
      preLoaderRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdPaymentControlsTypeIdImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/acquirers/$acquirerId/users/$id/edit': {
      id: '/u/$localId/_staff/staff/acquirers/$acquirerId/users/$id/edit'
      path: '/staff/acquirers/$acquirerId/users/$id/edit'
      fullPath: '/u/$localId/staff/acquirers/$acquirerId/users/$id/edit'
      preLoaderRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdUsersIdEditImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/merchants/$merchantId/api-keys/$id/edit': {
      id: '/u/$localId/_staff/staff/merchants/$merchantId/api-keys/$id/edit'
      path: '/staff/merchants/$merchantId/api-keys/$id/edit'
      fullPath: '/u/$localId/staff/merchants/$merchantId/api-keys/$id/edit'
      preLoaderRoute: typeof ULocalIdStaffStaffMerchantsMerchantIdApiKeysIdEditImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/merchants/$merchantId/links/$id/edit': {
      id: '/u/$localId/_staff/staff/merchants/$merchantId/links/$id/edit'
      path: '/staff/merchants/$merchantId/links/$id/edit'
      fullPath: '/u/$localId/staff/merchants/$merchantId/links/$id/edit'
      preLoaderRoute: typeof ULocalIdStaffStaffMerchantsMerchantIdLinksIdEditImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/merchants/$merchantId/payment-controls/$type/$id': {
      id: '/u/$localId/_staff/staff/merchants/$merchantId/payment-controls/$type/$id'
      path: '/staff/merchants/$merchantId/payment-controls/$type/$id'
      fullPath: '/u/$localId/staff/merchants/$merchantId/payment-controls/$type/$id'
      preLoaderRoute: typeof ULocalIdStaffStaffMerchantsMerchantIdPaymentControlsTypeIdImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/merchants/$merchantId/users/$id/edit': {
      id: '/u/$localId/_staff/staff/merchants/$merchantId/users/$id/edit'
      path: '/staff/merchants/$merchantId/users/$id/edit'
      fullPath: '/u/$localId/staff/merchants/$merchantId/users/$id/edit'
      preLoaderRoute: typeof ULocalIdStaffStaffMerchantsMerchantIdUsersIdEditImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_acquirer/acquirer/merchants/$merchantId/payment-controls/$type/': {
      id: '/u/$localId/_acquirer/acquirer/merchants/$merchantId/payment-controls/$type/'
      path: '/payment-controls/$type'
      fullPath: '/u/$localId/acquirer/merchants/$merchantId/payment-controls/$type'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerMerchantsMerchantIdPaymentControlsTypeIndexImport
      parentRoute: typeof ULocalIdAcquirerAcquirerMerchantsMerchantIdImport
    }
    '/u/$localId/_acquirer/acquirer/merchants/$merchantId/links/$id/': {
      id: '/u/$localId/_acquirer/acquirer/merchants/$merchantId/links/$id/'
      path: '/acquirer/merchants/$merchantId/links/$id'
      fullPath: '/u/$localId/acquirer/merchants/$merchantId/links/$id'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerMerchantsMerchantIdLinksIdIndexImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_acquirer/acquirer/merchants/$merchantId/users/$id/': {
      id: '/u/$localId/_acquirer/acquirer/merchants/$merchantId/users/$id/'
      path: '/acquirer/merchants/$merchantId/users/$id'
      fullPath: '/u/$localId/acquirer/merchants/$merchantId/users/$id'
      preLoaderRoute: typeof ULocalIdAcquirerAcquirerMerchantsMerchantIdUsersIdIndexImport
      parentRoute: typeof ULocalIdAcquirerImport
    }
    '/u/$localId/_staff/staff/acquirers/$acquirerId/payment-controls/$type/': {
      id: '/u/$localId/_staff/staff/acquirers/$acquirerId/payment-controls/$type/'
      path: '/payment-controls/$type'
      fullPath: '/u/$localId/staff/acquirers/$acquirerId/payment-controls/$type'
      preLoaderRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdPaymentControlsTypeIndexImport
      parentRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdImport
    }
    '/u/$localId/_staff/staff/acquirers/$acquirerId/api-keys/$id/': {
      id: '/u/$localId/_staff/staff/acquirers/$acquirerId/api-keys/$id/'
      path: '/staff/acquirers/$acquirerId/api-keys/$id'
      fullPath: '/u/$localId/staff/acquirers/$acquirerId/api-keys/$id'
      preLoaderRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdApiKeysIdIndexImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/acquirers/$acquirerId/links/$id/': {
      id: '/u/$localId/_staff/staff/acquirers/$acquirerId/links/$id/'
      path: '/staff/acquirers/$acquirerId/links/$id'
      fullPath: '/u/$localId/staff/acquirers/$acquirerId/links/$id'
      preLoaderRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdLinksIdIndexImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/acquirers/$acquirerId/users/$id/': {
      id: '/u/$localId/_staff/staff/acquirers/$acquirerId/users/$id/'
      path: '/staff/acquirers/$acquirerId/users/$id'
      fullPath: '/u/$localId/staff/acquirers/$acquirerId/users/$id'
      preLoaderRoute: typeof ULocalIdStaffStaffAcquirersAcquirerIdUsersIdIndexImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/merchants/$merchantId/payment-controls/$type/': {
      id: '/u/$localId/_staff/staff/merchants/$merchantId/payment-controls/$type/'
      path: '/payment-controls/$type'
      fullPath: '/u/$localId/staff/merchants/$merchantId/payment-controls/$type'
      preLoaderRoute: typeof ULocalIdStaffStaffMerchantsMerchantIdPaymentControlsTypeIndexImport
      parentRoute: typeof ULocalIdStaffStaffMerchantsMerchantIdImport
    }
    '/u/$localId/_staff/staff/merchants/$merchantId/api-keys/$id/': {
      id: '/u/$localId/_staff/staff/merchants/$merchantId/api-keys/$id/'
      path: '/staff/merchants/$merchantId/api-keys/$id'
      fullPath: '/u/$localId/staff/merchants/$merchantId/api-keys/$id'
      preLoaderRoute: typeof ULocalIdStaffStaffMerchantsMerchantIdApiKeysIdIndexImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/merchants/$merchantId/links/$id/': {
      id: '/u/$localId/_staff/staff/merchants/$merchantId/links/$id/'
      path: '/staff/merchants/$merchantId/links/$id'
      fullPath: '/u/$localId/staff/merchants/$merchantId/links/$id'
      preLoaderRoute: typeof ULocalIdStaffStaffMerchantsMerchantIdLinksIdIndexImport
      parentRoute: typeof ULocalIdStaffImport
    }
    '/u/$localId/_staff/staff/merchants/$merchantId/users/$id/': {
      id: '/u/$localId/_staff/staff/merchants/$merchantId/users/$id/'
      path: '/staff/merchants/$merchantId/users/$id'
      fullPath: '/u/$localId/staff/merchants/$merchantId/users/$id'
      preLoaderRoute: typeof ULocalIdStaffStaffMerchantsMerchantIdUsersIdIndexImport
      parentRoute: typeof ULocalIdStaffImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexRoute,
  AcquirerInvitationRoute,
  AcquirerLoginRoute,
  AcquirerResetPasswordRoute,
  MerchantInvitationRoute,
  MerchantLoginRoute,
  MerchantResetPasswordRoute,
  StaffInvitationRoute,
  StaffLoginRoute,
  StaffResetPasswordRoute,
  UIndexRoute,
  ULocalIdRoute: ULocalIdRoute.addChildren({
    ULocalIdAcquirerRoute: ULocalIdAcquirerRoute.addChildren({
      ULocalIdAcquirerAcquirerForbiddenLazyRoute,
      ULocalIdAcquirerAcquirerIndexRoute,
      ULocalIdAcquirerAcquirerAgreementsIdRoute:
        ULocalIdAcquirerAcquirerAgreementsIdRoute.addChildren({
          ULocalIdAcquirerAcquirerAgreementsIdApiResponseRoute,
          ULocalIdAcquirerAcquirerAgreementsIdOrdersRoute,
        }),
      ULocalIdAcquirerAcquirerApiKeysNewRoute,
      ULocalIdAcquirerAcquirerAuditLogsIdRoute,
      ULocalIdAcquirerAcquirerCardAuthenticationsIdRoute:
        ULocalIdAcquirerAcquirerCardAuthenticationsIdRoute.addChildren({
          ULocalIdAcquirerAcquirerCardAuthenticationsIdApiResponseRoute,
          ULocalIdAcquirerAcquirerCardAuthenticationsIdAuthRoute,
          ULocalIdAcquirerAcquirerCardAuthenticationsIdMerchantRoute,
        }),
      ULocalIdAcquirerAcquirerLinksIdRoute,
      ULocalIdAcquirerAcquirerMerchantsMerchantIdRoute:
        ULocalIdAcquirerAcquirerMerchantsMerchantIdRoute.addChildren({
          ULocalIdAcquirerAcquirerMerchantsMerchantIdCardAuthenticationsRoute,
          ULocalIdAcquirerAcquirerMerchantsMerchantIdLinksRoute,
          ULocalIdAcquirerAcquirerMerchantsMerchantIdOrdersRoute,
          ULocalIdAcquirerAcquirerMerchantsMerchantIdTransactionsRoute,
          ULocalIdAcquirerAcquirerMerchantsMerchantIdUsersRoute,
          ULocalIdAcquirerAcquirerMerchantsMerchantIdPaymentControlsIndexRoute,
          ULocalIdAcquirerAcquirerMerchantsMerchantIdPaymentControlsTypeIndexRoute,
        }),
      ULocalIdAcquirerAcquirerMerchantsNewRoute,
      ULocalIdAcquirerAcquirerOrdersIdRoute:
        ULocalIdAcquirerAcquirerOrdersIdRoute.addChildren({
          ULocalIdAcquirerAcquirerOrdersIdAgreementRoute,
          ULocalIdAcquirerAcquirerOrdersIdApiResponseRoute,
          ULocalIdAcquirerAcquirerOrdersIdMerchantRoute,
          ULocalIdAcquirerAcquirerOrdersIdSourceRoute,
          ULocalIdAcquirerAcquirerOrdersIdSubMerchantRoute,
          ULocalIdAcquirerAcquirerOrdersIdTransactionsRoute,
        }),
      ULocalIdAcquirerAcquirerUsersNewRoute,
      ULocalIdAcquirerAcquirerAgreementsIndexRoute,
      ULocalIdAcquirerAcquirerApiKeysIndexRoute,
      ULocalIdAcquirerAcquirerAuditLogsIndexRoute,
      ULocalIdAcquirerAcquirerCardAuthenticationsIndexRoute,
      ULocalIdAcquirerAcquirerEodStatementsIndexRoute,
      ULocalIdAcquirerAcquirerLinksIndexRoute,
      ULocalIdAcquirerAcquirerMerchantsIndexRoute,
      ULocalIdAcquirerAcquirerOrdersIndexRoute,
      ULocalIdAcquirerAcquirerPaymentControlsIndexRoute,
      ULocalIdAcquirerAcquirerSettingsIndexRoute,
      ULocalIdAcquirerAcquirerTransactionsIndexRoute,
      ULocalIdAcquirerAcquirerUsersIndexRoute,
      ULocalIdAcquirerAcquirerApiKeysIdEditRoute,
      ULocalIdAcquirerAcquirerMerchantsMerchantIdEditRoute,
      ULocalIdAcquirerAcquirerPaymentControlsTypeIdRoute,
      ULocalIdAcquirerAcquirerUsersIdEditRoute,
      ULocalIdAcquirerAcquirerApiKeysIdIndexRoute,
      ULocalIdAcquirerAcquirerPaymentControlsTypeIndexRoute,
      ULocalIdAcquirerAcquirerUsersIdIndexRoute,
      ULocalIdAcquirerAcquirerMerchantsMerchantIdLinksNewRoute,
      ULocalIdAcquirerAcquirerMerchantsMerchantIdUsersNewRoute,
      ULocalIdAcquirerAcquirerMerchantsMerchantIdLinksIdEditRoute,
      ULocalIdAcquirerAcquirerMerchantsMerchantIdPaymentControlsTypeIdRoute,
      ULocalIdAcquirerAcquirerMerchantsMerchantIdUsersIdEditRoute,
      ULocalIdAcquirerAcquirerMerchantsMerchantIdLinksIdIndexRoute,
      ULocalIdAcquirerAcquirerMerchantsMerchantIdUsersIdIndexRoute,
    }),
    ULocalIdMerchantRoute: ULocalIdMerchantRoute.addChildren({
      ULocalIdMerchantMerchantForbiddenLazyRoute,
      ULocalIdMerchantMerchantIndexRoute,
      ULocalIdMerchantMerchantAgreementsIdRoute:
        ULocalIdMerchantMerchantAgreementsIdRoute.addChildren({
          ULocalIdMerchantMerchantAgreementsIdApiResponseRoute,
          ULocalIdMerchantMerchantAgreementsIdOrdersRoute,
        }),
      ULocalIdMerchantMerchantApiKeysNewRoute,
      ULocalIdMerchantMerchantAuditLogsIdRoute,
      ULocalIdMerchantMerchantCardAuthenticationsIdRoute:
        ULocalIdMerchantMerchantCardAuthenticationsIdRoute.addChildren({
          ULocalIdMerchantMerchantCardAuthenticationsIdApiResponseRoute,
          ULocalIdMerchantMerchantCardAuthenticationsIdAuthRoute,
          ULocalIdMerchantMerchantCardAuthenticationsIdMerchantRoute,
        }),
      ULocalIdMerchantMerchantLinksIdRoute,
      ULocalIdMerchantMerchantOrdersIdRoute:
        ULocalIdMerchantMerchantOrdersIdRoute.addChildren({
          ULocalIdMerchantMerchantOrdersIdAgreementRoute,
          ULocalIdMerchantMerchantOrdersIdApiResponseRoute,
          ULocalIdMerchantMerchantOrdersIdMerchantRoute,
          ULocalIdMerchantMerchantOrdersIdSourceRoute,
          ULocalIdMerchantMerchantOrdersIdSubMerchantRoute,
          ULocalIdMerchantMerchantOrdersIdTransactionsRoute,
        }),
      ULocalIdMerchantMerchantUsersNewRoute,
      ULocalIdMerchantMerchantAgreementsIndexRoute,
      ULocalIdMerchantMerchantApiKeysIndexRoute,
      ULocalIdMerchantMerchantAuditLogsIndexRoute,
      ULocalIdMerchantMerchantCardAuthenticationsIndexRoute,
      ULocalIdMerchantMerchantLinksIndexRoute,
      ULocalIdMerchantMerchantOrdersIndexRoute,
      ULocalIdMerchantMerchantPaymentControlsIndexRoute,
      ULocalIdMerchantMerchantSettingsIndexRoute,
      ULocalIdMerchantMerchantTransactionsIndexRoute,
      ULocalIdMerchantMerchantUsersIndexRoute,
      ULocalIdMerchantMerchantApiKeysIdEditRoute,
      ULocalIdMerchantMerchantPaymentControlsTypeIdRoute,
      ULocalIdMerchantMerchantUsersIdEditRoute,
      ULocalIdMerchantMerchantApiKeysIdIndexRoute,
      ULocalIdMerchantMerchantPaymentControlsTypeIndexRoute,
      ULocalIdMerchantMerchantUsersIdIndexRoute,
    }),
    ULocalIdStaffRoute: ULocalIdStaffRoute.addChildren({
      ULocalIdStaffStaffForbiddenLazyRoute,
      ULocalIdStaffStaffIndexRoute,
      ULocalIdStaffStaffAcquirersAcquirerIdRoute:
        ULocalIdStaffStaffAcquirersAcquirerIdRoute.addChildren({
          ULocalIdStaffStaffAcquirersAcquirerIdApiKeysRoute,
          ULocalIdStaffStaffAcquirersAcquirerIdLinksRoute,
          ULocalIdStaffStaffAcquirersAcquirerIdMerchantsRoute,
          ULocalIdStaffStaffAcquirersAcquirerIdOrdersRoute,
          ULocalIdStaffStaffAcquirersAcquirerIdTransactionsRoute,
          ULocalIdStaffStaffAcquirersAcquirerIdUsersRoute,
          ULocalIdStaffStaffAcquirersAcquirerIdPaymentControlsIndexRoute,
          ULocalIdStaffStaffAcquirersAcquirerIdPaymentControlsTypeIndexRoute,
        }),
      ULocalIdStaffStaffAcquirersNewRoute,
      ULocalIdStaffStaffAgreementsIdRoute:
        ULocalIdStaffStaffAgreementsIdRoute.addChildren({
          ULocalIdStaffStaffAgreementsIdApiResponseRoute,
          ULocalIdStaffStaffAgreementsIdOrdersRoute,
        }),
      ULocalIdStaffStaffAuditLogsIdRoute,
      ULocalIdStaffStaffBenchUsersNewRoute,
      ULocalIdStaffStaffBinsImportRoute,
      ULocalIdStaffStaffCardAuthenticationsIdRoute:
        ULocalIdStaffStaffCardAuthenticationsIdRoute.addChildren({
          ULocalIdStaffStaffCardAuthenticationsIdApiResponseRoute,
          ULocalIdStaffStaffCardAuthenticationsIdAuthRoute,
          ULocalIdStaffStaffCardAuthenticationsIdMerchantRoute,
        }),
      ULocalIdStaffStaffMerchantsMerchantIdRoute:
        ULocalIdStaffStaffMerchantsMerchantIdRoute.addChildren({
          ULocalIdStaffStaffMerchantsMerchantIdApiKeysRoute,
          ULocalIdStaffStaffMerchantsMerchantIdLinksRoute,
          ULocalIdStaffStaffMerchantsMerchantIdOrdersRoute,
          ULocalIdStaffStaffMerchantsMerchantIdTransactionsRoute,
          ULocalIdStaffStaffMerchantsMerchantIdUsersRoute,
          ULocalIdStaffStaffMerchantsMerchantIdPaymentControlsIndexRoute,
          ULocalIdStaffStaffMerchantsMerchantIdPaymentControlsTypeIndexRoute,
        }),
      ULocalIdStaffStaffOrdersIdRoute:
        ULocalIdStaffStaffOrdersIdRoute.addChildren({
          ULocalIdStaffStaffOrdersIdAgreementRoute,
          ULocalIdStaffStaffOrdersIdApiResponseRoute,
          ULocalIdStaffStaffOrdersIdMerchantRoute,
          ULocalIdStaffStaffOrdersIdSourceRoute,
          ULocalIdStaffStaffOrdersIdSubMerchantRoute,
          ULocalIdStaffStaffOrdersIdTransactionsRoute,
        }),
      ULocalIdStaffStaffTdsMerchantsIdRoute,
      ULocalIdStaffStaffUsersNewRoute,
      ULocalIdStaffStaffAcquirersIndexRoute,
      ULocalIdStaffStaffAgreementsIndexRoute,
      ULocalIdStaffStaffAuditLogsIndexRoute,
      ULocalIdStaffStaffBenchUsersIndexRoute,
      ULocalIdStaffStaffCardAuthenticationsIndexRoute,
      ULocalIdStaffStaffMerchantsIndexRoute,
      ULocalIdStaffStaffOrdersIndexRoute,
      ULocalIdStaffStaffSettingsIndexRoute,
      ULocalIdStaffStaffTdsMerchantsIndexRoute,
      ULocalIdStaffStaffTransactionsIndexRoute,
      ULocalIdStaffStaffUsersIndexRoute,
      ULocalIdStaffStaffAcquirersAcquirerIdEditRoute,
      ULocalIdStaffStaffBenchUsersIdEditRoute,
      ULocalIdStaffStaffMerchantsMerchantIdEditRoute,
      ULocalIdStaffStaffUsersIdEditRoute,
      ULocalIdStaffStaffUsersIdIndexRoute,
      ULocalIdStaffStaffAcquirersAcquirerIdApiKeysNewRoute,
      ULocalIdStaffStaffAcquirersAcquirerIdLinksNewRoute,
      ULocalIdStaffStaffAcquirersAcquirerIdMerchantsNewRoute,
      ULocalIdStaffStaffAcquirersAcquirerIdUsersNewRoute,
      ULocalIdStaffStaffMerchantsMerchantIdApiKeysNewRoute,
      ULocalIdStaffStaffMerchantsMerchantIdLinksNewRoute,
      ULocalIdStaffStaffMerchantsMerchantIdUsersNewRoute,
      ULocalIdStaffStaffAcquirersAcquirerIdApiKeysIdEditRoute,
      ULocalIdStaffStaffAcquirersAcquirerIdLinksIdEditRoute,
      ULocalIdStaffStaffAcquirersAcquirerIdPaymentControlsTypeIdRoute,
      ULocalIdStaffStaffAcquirersAcquirerIdUsersIdEditRoute,
      ULocalIdStaffStaffMerchantsMerchantIdApiKeysIdEditRoute,
      ULocalIdStaffStaffMerchantsMerchantIdLinksIdEditRoute,
      ULocalIdStaffStaffMerchantsMerchantIdPaymentControlsTypeIdRoute,
      ULocalIdStaffStaffMerchantsMerchantIdUsersIdEditRoute,
      ULocalIdStaffStaffAcquirersAcquirerIdApiKeysIdIndexRoute,
      ULocalIdStaffStaffAcquirersAcquirerIdLinksIdIndexRoute,
      ULocalIdStaffStaffAcquirersAcquirerIdUsersIdIndexRoute,
      ULocalIdStaffStaffMerchantsMerchantIdApiKeysIdIndexRoute,
      ULocalIdStaffStaffMerchantsMerchantIdLinksIdIndexRoute,
      ULocalIdStaffStaffMerchantsMerchantIdUsersIdIndexRoute,
    }),
    ULocalIdIndexRoute,
  }),
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/acquirer/invitation",
        "/acquirer/login",
        "/acquirer/reset-password",
        "/merchant/invitation",
        "/merchant/login",
        "/merchant/reset-password",
        "/staff/invitation",
        "/staff/login",
        "/staff/reset-password",
        "/u/",
        "/u/$localId"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/acquirer/invitation": {
      "filePath": "acquirer/invitation.tsx"
    },
    "/acquirer/login": {
      "filePath": "acquirer/login.tsx"
    },
    "/acquirer/reset-password": {
      "filePath": "acquirer/reset-password.tsx"
    },
    "/merchant/invitation": {
      "filePath": "merchant/invitation.tsx"
    },
    "/merchant/login": {
      "filePath": "merchant/login.tsx"
    },
    "/merchant/reset-password": {
      "filePath": "merchant/reset-password.tsx"
    },
    "/staff/invitation": {
      "filePath": "staff/invitation.tsx"
    },
    "/staff/login": {
      "filePath": "staff/login.tsx"
    },
    "/staff/reset-password": {
      "filePath": "staff/reset-password.tsx"
    },
    "/u/": {
      "filePath": "u/index.tsx"
    },
    "/u/$localId": {
      "filePath": "u/$localId",
      "children": [
        "/u/$localId/_acquirer",
        "/u/$localId/_merchant",
        "/u/$localId/_staff",
        "/u/$localId/"
      ]
    },
    "/u/$localId/_acquirer": {
      "filePath": "u/$localId/_acquirer.tsx",
      "parent": "/u/$localId",
      "children": [
        "/u/$localId/_acquirer/acquirer/forbidden",
        "/u/$localId/_acquirer/acquirer/",
        "/u/$localId/_acquirer/acquirer/agreements/$id",
        "/u/$localId/_acquirer/acquirer/api-keys/new",
        "/u/$localId/_acquirer/acquirer/audit-logs/$id",
        "/u/$localId/_acquirer/acquirer/card-authentications/$id",
        "/u/$localId/_acquirer/acquirer/links/$id",
        "/u/$localId/_acquirer/acquirer/merchants/$merchantId",
        "/u/$localId/_acquirer/acquirer/merchants/new",
        "/u/$localId/_acquirer/acquirer/orders/$id",
        "/u/$localId/_acquirer/acquirer/users/new",
        "/u/$localId/_acquirer/acquirer/agreements/",
        "/u/$localId/_acquirer/acquirer/api-keys/",
        "/u/$localId/_acquirer/acquirer/audit-logs/",
        "/u/$localId/_acquirer/acquirer/card-authentications/",
        "/u/$localId/_acquirer/acquirer/eod-statements/",
        "/u/$localId/_acquirer/acquirer/links/",
        "/u/$localId/_acquirer/acquirer/merchants/",
        "/u/$localId/_acquirer/acquirer/orders/",
        "/u/$localId/_acquirer/acquirer/payment-controls/",
        "/u/$localId/_acquirer/acquirer/settings/",
        "/u/$localId/_acquirer/acquirer/transactions/",
        "/u/$localId/_acquirer/acquirer/users/",
        "/u/$localId/_acquirer/acquirer/api-keys/$id/edit",
        "/u/$localId/_acquirer/acquirer/merchants/$merchantId/edit",
        "/u/$localId/_acquirer/acquirer/payment-controls/$type/$id",
        "/u/$localId/_acquirer/acquirer/users/$id/edit",
        "/u/$localId/_acquirer/acquirer/api-keys/$id/",
        "/u/$localId/_acquirer/acquirer/payment-controls/$type/",
        "/u/$localId/_acquirer/acquirer/users/$id/",
        "/u/$localId/_acquirer/acquirer/merchants/$merchantId/links/new",
        "/u/$localId/_acquirer/acquirer/merchants/$merchantId/users/new",
        "/u/$localId/_acquirer/acquirer/merchants/$merchantId/links/$id/edit",
        "/u/$localId/_acquirer/acquirer/merchants/$merchantId/payment-controls/$type/$id",
        "/u/$localId/_acquirer/acquirer/merchants/$merchantId/users/$id/edit",
        "/u/$localId/_acquirer/acquirer/merchants/$merchantId/links/$id/",
        "/u/$localId/_acquirer/acquirer/merchants/$merchantId/users/$id/"
      ]
    },
    "/u/$localId/_merchant": {
      "filePath": "u/$localId/_merchant.tsx",
      "parent": "/u/$localId",
      "children": [
        "/u/$localId/_merchant/merchant/forbidden",
        "/u/$localId/_merchant/merchant/",
        "/u/$localId/_merchant/merchant/agreements/$id",
        "/u/$localId/_merchant/merchant/api-keys/new",
        "/u/$localId/_merchant/merchant/audit-logs/$id",
        "/u/$localId/_merchant/merchant/card-authentications/$id",
        "/u/$localId/_merchant/merchant/links/$id",
        "/u/$localId/_merchant/merchant/orders/$id",
        "/u/$localId/_merchant/merchant/users/new",
        "/u/$localId/_merchant/merchant/agreements/",
        "/u/$localId/_merchant/merchant/api-keys/",
        "/u/$localId/_merchant/merchant/audit-logs/",
        "/u/$localId/_merchant/merchant/card-authentications/",
        "/u/$localId/_merchant/merchant/links/",
        "/u/$localId/_merchant/merchant/orders/",
        "/u/$localId/_merchant/merchant/payment-controls/",
        "/u/$localId/_merchant/merchant/settings/",
        "/u/$localId/_merchant/merchant/transactions/",
        "/u/$localId/_merchant/merchant/users/",
        "/u/$localId/_merchant/merchant/api-keys/$id/edit",
        "/u/$localId/_merchant/merchant/payment-controls/$type/$id",
        "/u/$localId/_merchant/merchant/users/$id/edit",
        "/u/$localId/_merchant/merchant/api-keys/$id/",
        "/u/$localId/_merchant/merchant/payment-controls/$type/",
        "/u/$localId/_merchant/merchant/users/$id/"
      ]
    },
    "/u/$localId/_staff": {
      "filePath": "u/$localId/_staff.tsx",
      "parent": "/u/$localId",
      "children": [
        "/u/$localId/_staff/staff/forbidden",
        "/u/$localId/_staff/staff/",
        "/u/$localId/_staff/staff/acquirers/$acquirerId",
        "/u/$localId/_staff/staff/acquirers/new",
        "/u/$localId/_staff/staff/agreements/$id",
        "/u/$localId/_staff/staff/audit-logs/$id",
        "/u/$localId/_staff/staff/bench-users/new",
        "/u/$localId/_staff/staff/bins/import",
        "/u/$localId/_staff/staff/card-authentications/$id",
        "/u/$localId/_staff/staff/merchants/$merchantId",
        "/u/$localId/_staff/staff/orders/$id",
        "/u/$localId/_staff/staff/tds-merchants/$id",
        "/u/$localId/_staff/staff/users/new",
        "/u/$localId/_staff/staff/acquirers/",
        "/u/$localId/_staff/staff/agreements/",
        "/u/$localId/_staff/staff/audit-logs/",
        "/u/$localId/_staff/staff/bench-users/",
        "/u/$localId/_staff/staff/card-authentications/",
        "/u/$localId/_staff/staff/merchants/",
        "/u/$localId/_staff/staff/orders/",
        "/u/$localId/_staff/staff/settings/",
        "/u/$localId/_staff/staff/tds-merchants/",
        "/u/$localId/_staff/staff/transactions/",
        "/u/$localId/_staff/staff/users/",
        "/u/$localId/_staff/staff/acquirers/$acquirerId/edit",
        "/u/$localId/_staff/staff/bench-users/$id/edit",
        "/u/$localId/_staff/staff/merchants/$merchantId/edit",
        "/u/$localId/_staff/staff/users/$id/edit",
        "/u/$localId/_staff/staff/users/$id/",
        "/u/$localId/_staff/staff/acquirers/$acquirerId/api-keys/new",
        "/u/$localId/_staff/staff/acquirers/$acquirerId/links/new",
        "/u/$localId/_staff/staff/acquirers/$acquirerId/merchants/new",
        "/u/$localId/_staff/staff/acquirers/$acquirerId/users/new",
        "/u/$localId/_staff/staff/merchants/$merchantId/api-keys/new",
        "/u/$localId/_staff/staff/merchants/$merchantId/links/new",
        "/u/$localId/_staff/staff/merchants/$merchantId/users/new",
        "/u/$localId/_staff/staff/acquirers/$acquirerId/api-keys/$id/edit",
        "/u/$localId/_staff/staff/acquirers/$acquirerId/links/$id/edit",
        "/u/$localId/_staff/staff/acquirers/$acquirerId/payment-controls/$type/$id",
        "/u/$localId/_staff/staff/acquirers/$acquirerId/users/$id/edit",
        "/u/$localId/_staff/staff/merchants/$merchantId/api-keys/$id/edit",
        "/u/$localId/_staff/staff/merchants/$merchantId/links/$id/edit",
        "/u/$localId/_staff/staff/merchants/$merchantId/payment-controls/$type/$id",
        "/u/$localId/_staff/staff/merchants/$merchantId/users/$id/edit",
        "/u/$localId/_staff/staff/acquirers/$acquirerId/api-keys/$id/",
        "/u/$localId/_staff/staff/acquirers/$acquirerId/links/$id/",
        "/u/$localId/_staff/staff/acquirers/$acquirerId/users/$id/",
        "/u/$localId/_staff/staff/merchants/$merchantId/api-keys/$id/",
        "/u/$localId/_staff/staff/merchants/$merchantId/links/$id/",
        "/u/$localId/_staff/staff/merchants/$merchantId/users/$id/"
      ]
    },
    "/u/$localId/": {
      "filePath": "u/$localId/index.tsx",
      "parent": "/u/$localId"
    },
    "/u/$localId/_acquirer/acquirer/forbidden": {
      "filePath": "u/$localId/_acquirer.acquirer/forbidden.lazy.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_merchant/merchant/forbidden": {
      "filePath": "u/$localId/_merchant.merchant/forbidden.lazy.tsx",
      "parent": "/u/$localId/_merchant"
    },
    "/u/$localId/_staff/staff/forbidden": {
      "filePath": "u/$localId/_staff.staff/forbidden.lazy.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_acquirer/acquirer/": {
      "filePath": "u/$localId/_acquirer.acquirer/index.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_merchant/merchant/": {
      "filePath": "u/$localId/_merchant.merchant/index.tsx",
      "parent": "/u/$localId/_merchant"
    },
    "/u/$localId/_staff/staff/": {
      "filePath": "u/$localId/_staff.staff/index.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_acquirer/acquirer/agreements/$id": {
      "filePath": "u/$localId/_acquirer.acquirer/agreements/$id.tsx",
      "parent": "/u/$localId/_acquirer",
      "children": [
        "/u/$localId/_acquirer/acquirer/agreements/$id/api-response",
        "/u/$localId/_acquirer/acquirer/agreements/$id/orders"
      ]
    },
    "/u/$localId/_acquirer/acquirer/api-keys/new": {
      "filePath": "u/$localId/_acquirer.acquirer/api-keys/new.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_acquirer/acquirer/audit-logs/$id": {
      "filePath": "u/$localId/_acquirer.acquirer/audit-logs/$id.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_acquirer/acquirer/card-authentications/$id": {
      "filePath": "u/$localId/_acquirer.acquirer/card-authentications/$id.tsx",
      "parent": "/u/$localId/_acquirer",
      "children": [
        "/u/$localId/_acquirer/acquirer/card-authentications/$id/apiResponse",
        "/u/$localId/_acquirer/acquirer/card-authentications/$id/auth",
        "/u/$localId/_acquirer/acquirer/card-authentications/$id/merchant"
      ]
    },
    "/u/$localId/_acquirer/acquirer/links/$id": {
      "filePath": "u/$localId/_acquirer.acquirer/links/$id.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_acquirer/acquirer/merchants/$merchantId": {
      "filePath": "u/$localId/_acquirer.acquirer/merchants/$merchantId.tsx",
      "parent": "/u/$localId/_acquirer",
      "children": [
        "/u/$localId/_acquirer/acquirer/merchants/$merchantId/card-authentications",
        "/u/$localId/_acquirer/acquirer/merchants/$merchantId/links",
        "/u/$localId/_acquirer/acquirer/merchants/$merchantId/orders",
        "/u/$localId/_acquirer/acquirer/merchants/$merchantId/transactions",
        "/u/$localId/_acquirer/acquirer/merchants/$merchantId/users",
        "/u/$localId/_acquirer/acquirer/merchants/$merchantId/payment-controls/",
        "/u/$localId/_acquirer/acquirer/merchants/$merchantId/payment-controls/$type/"
      ]
    },
    "/u/$localId/_acquirer/acquirer/merchants/new": {
      "filePath": "u/$localId/_acquirer.acquirer/merchants/new.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_acquirer/acquirer/orders/$id": {
      "filePath": "u/$localId/_acquirer.acquirer/orders/$id.tsx",
      "parent": "/u/$localId/_acquirer",
      "children": [
        "/u/$localId/_acquirer/acquirer/orders/$id/agreement",
        "/u/$localId/_acquirer/acquirer/orders/$id/apiResponse",
        "/u/$localId/_acquirer/acquirer/orders/$id/merchant",
        "/u/$localId/_acquirer/acquirer/orders/$id/source",
        "/u/$localId/_acquirer/acquirer/orders/$id/subMerchant",
        "/u/$localId/_acquirer/acquirer/orders/$id/transactions"
      ]
    },
    "/u/$localId/_acquirer/acquirer/users/new": {
      "filePath": "u/$localId/_acquirer.acquirer/users/new.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_merchant/merchant/agreements/$id": {
      "filePath": "u/$localId/_merchant.merchant/agreements/$id.tsx",
      "parent": "/u/$localId/_merchant",
      "children": [
        "/u/$localId/_merchant/merchant/agreements/$id/api-response",
        "/u/$localId/_merchant/merchant/agreements/$id/orders"
      ]
    },
    "/u/$localId/_merchant/merchant/api-keys/new": {
      "filePath": "u/$localId/_merchant.merchant/api-keys/new.tsx",
      "parent": "/u/$localId/_merchant"
    },
    "/u/$localId/_merchant/merchant/audit-logs/$id": {
      "filePath": "u/$localId/_merchant.merchant/audit-logs/$id.tsx",
      "parent": "/u/$localId/_merchant"
    },
    "/u/$localId/_merchant/merchant/card-authentications/$id": {
      "filePath": "u/$localId/_merchant.merchant/card-authentications/$id.tsx",
      "parent": "/u/$localId/_merchant",
      "children": [
        "/u/$localId/_merchant/merchant/card-authentications/$id/apiResponse",
        "/u/$localId/_merchant/merchant/card-authentications/$id/auth",
        "/u/$localId/_merchant/merchant/card-authentications/$id/merchant"
      ]
    },
    "/u/$localId/_merchant/merchant/links/$id": {
      "filePath": "u/$localId/_merchant.merchant/links/$id.tsx",
      "parent": "/u/$localId/_merchant"
    },
    "/u/$localId/_merchant/merchant/orders/$id": {
      "filePath": "u/$localId/_merchant.merchant/orders/$id.tsx",
      "parent": "/u/$localId/_merchant",
      "children": [
        "/u/$localId/_merchant/merchant/orders/$id/agreement",
        "/u/$localId/_merchant/merchant/orders/$id/apiResponse",
        "/u/$localId/_merchant/merchant/orders/$id/merchant",
        "/u/$localId/_merchant/merchant/orders/$id/source",
        "/u/$localId/_merchant/merchant/orders/$id/subMerchant",
        "/u/$localId/_merchant/merchant/orders/$id/transactions"
      ]
    },
    "/u/$localId/_merchant/merchant/users/new": {
      "filePath": "u/$localId/_merchant.merchant/users/new.tsx",
      "parent": "/u/$localId/_merchant"
    },
    "/u/$localId/_staff/staff/acquirers/$acquirerId": {
      "filePath": "u/$localId/_staff.staff/acquirers/$acquirerId.tsx",
      "parent": "/u/$localId/_staff",
      "children": [
        "/u/$localId/_staff/staff/acquirers/$acquirerId/api-keys",
        "/u/$localId/_staff/staff/acquirers/$acquirerId/links",
        "/u/$localId/_staff/staff/acquirers/$acquirerId/merchants",
        "/u/$localId/_staff/staff/acquirers/$acquirerId/orders",
        "/u/$localId/_staff/staff/acquirers/$acquirerId/transactions",
        "/u/$localId/_staff/staff/acquirers/$acquirerId/users",
        "/u/$localId/_staff/staff/acquirers/$acquirerId/payment-controls/",
        "/u/$localId/_staff/staff/acquirers/$acquirerId/payment-controls/$type/"
      ]
    },
    "/u/$localId/_staff/staff/acquirers/new": {
      "filePath": "u/$localId/_staff.staff/acquirers/new.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/agreements/$id": {
      "filePath": "u/$localId/_staff.staff/agreements/$id.tsx",
      "parent": "/u/$localId/_staff",
      "children": [
        "/u/$localId/_staff/staff/agreements/$id/api-response",
        "/u/$localId/_staff/staff/agreements/$id/orders"
      ]
    },
    "/u/$localId/_staff/staff/audit-logs/$id": {
      "filePath": "u/$localId/_staff.staff/audit-logs/$id.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/bench-users/new": {
      "filePath": "u/$localId/_staff.staff/bench-users/new.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/bins/import": {
      "filePath": "u/$localId/_staff.staff/bins/import.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/card-authentications/$id": {
      "filePath": "u/$localId/_staff.staff/card-authentications/$id.tsx",
      "parent": "/u/$localId/_staff",
      "children": [
        "/u/$localId/_staff/staff/card-authentications/$id/apiResponse",
        "/u/$localId/_staff/staff/card-authentications/$id/auth",
        "/u/$localId/_staff/staff/card-authentications/$id/merchant"
      ]
    },
    "/u/$localId/_staff/staff/merchants/$merchantId": {
      "filePath": "u/$localId/_staff.staff/merchants/$merchantId.tsx",
      "parent": "/u/$localId/_staff",
      "children": [
        "/u/$localId/_staff/staff/merchants/$merchantId/api-keys",
        "/u/$localId/_staff/staff/merchants/$merchantId/links",
        "/u/$localId/_staff/staff/merchants/$merchantId/orders",
        "/u/$localId/_staff/staff/merchants/$merchantId/transactions",
        "/u/$localId/_staff/staff/merchants/$merchantId/users",
        "/u/$localId/_staff/staff/merchants/$merchantId/payment-controls/",
        "/u/$localId/_staff/staff/merchants/$merchantId/payment-controls/$type/"
      ]
    },
    "/u/$localId/_staff/staff/orders/$id": {
      "filePath": "u/$localId/_staff.staff/orders/$id.tsx",
      "parent": "/u/$localId/_staff",
      "children": [
        "/u/$localId/_staff/staff/orders/$id/agreement",
        "/u/$localId/_staff/staff/orders/$id/apiResponse",
        "/u/$localId/_staff/staff/orders/$id/merchant",
        "/u/$localId/_staff/staff/orders/$id/source",
        "/u/$localId/_staff/staff/orders/$id/subMerchant",
        "/u/$localId/_staff/staff/orders/$id/transactions"
      ]
    },
    "/u/$localId/_staff/staff/tds-merchants/$id": {
      "filePath": "u/$localId/_staff.staff/tds-merchants/$id.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/users/new": {
      "filePath": "u/$localId/_staff.staff/users/new.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_acquirer/acquirer/agreements/": {
      "filePath": "u/$localId/_acquirer.acquirer/agreements/index.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_acquirer/acquirer/api-keys/": {
      "filePath": "u/$localId/_acquirer.acquirer/api-keys/index.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_acquirer/acquirer/audit-logs/": {
      "filePath": "u/$localId/_acquirer.acquirer/audit-logs/index.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_acquirer/acquirer/card-authentications/": {
      "filePath": "u/$localId/_acquirer.acquirer/card-authentications/index.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_acquirer/acquirer/eod-statements/": {
      "filePath": "u/$localId/_acquirer.acquirer/eod-statements/index.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_acquirer/acquirer/links/": {
      "filePath": "u/$localId/_acquirer.acquirer/links/index.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_acquirer/acquirer/merchants/": {
      "filePath": "u/$localId/_acquirer.acquirer/merchants/index.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_acquirer/acquirer/orders/": {
      "filePath": "u/$localId/_acquirer.acquirer/orders/index.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_acquirer/acquirer/payment-controls/": {
      "filePath": "u/$localId/_acquirer.acquirer/payment-controls/index.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_acquirer/acquirer/settings/": {
      "filePath": "u/$localId/_acquirer.acquirer/settings/index.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_acquirer/acquirer/transactions/": {
      "filePath": "u/$localId/_acquirer.acquirer/transactions/index.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_acquirer/acquirer/users/": {
      "filePath": "u/$localId/_acquirer.acquirer/users/index.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_merchant/merchant/agreements/": {
      "filePath": "u/$localId/_merchant.merchant/agreements/index.tsx",
      "parent": "/u/$localId/_merchant"
    },
    "/u/$localId/_merchant/merchant/api-keys/": {
      "filePath": "u/$localId/_merchant.merchant/api-keys/index.tsx",
      "parent": "/u/$localId/_merchant"
    },
    "/u/$localId/_merchant/merchant/audit-logs/": {
      "filePath": "u/$localId/_merchant.merchant/audit-logs/index.tsx",
      "parent": "/u/$localId/_merchant"
    },
    "/u/$localId/_merchant/merchant/card-authentications/": {
      "filePath": "u/$localId/_merchant.merchant/card-authentications/index.tsx",
      "parent": "/u/$localId/_merchant"
    },
    "/u/$localId/_merchant/merchant/links/": {
      "filePath": "u/$localId/_merchant.merchant/links/index.tsx",
      "parent": "/u/$localId/_merchant"
    },
    "/u/$localId/_merchant/merchant/orders/": {
      "filePath": "u/$localId/_merchant.merchant/orders/index.tsx",
      "parent": "/u/$localId/_merchant"
    },
    "/u/$localId/_merchant/merchant/payment-controls/": {
      "filePath": "u/$localId/_merchant.merchant/payment-controls/index.tsx",
      "parent": "/u/$localId/_merchant"
    },
    "/u/$localId/_merchant/merchant/settings/": {
      "filePath": "u/$localId/_merchant.merchant/settings/index.tsx",
      "parent": "/u/$localId/_merchant"
    },
    "/u/$localId/_merchant/merchant/transactions/": {
      "filePath": "u/$localId/_merchant.merchant/transactions/index.tsx",
      "parent": "/u/$localId/_merchant"
    },
    "/u/$localId/_merchant/merchant/users/": {
      "filePath": "u/$localId/_merchant.merchant/users/index.tsx",
      "parent": "/u/$localId/_merchant"
    },
    "/u/$localId/_staff/staff/acquirers/": {
      "filePath": "u/$localId/_staff.staff/acquirers/index.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/agreements/": {
      "filePath": "u/$localId/_staff.staff/agreements/index.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/audit-logs/": {
      "filePath": "u/$localId/_staff.staff/audit-logs/index.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/bench-users/": {
      "filePath": "u/$localId/_staff.staff/bench-users/index.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/card-authentications/": {
      "filePath": "u/$localId/_staff.staff/card-authentications/index.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/merchants/": {
      "filePath": "u/$localId/_staff.staff/merchants/index.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/orders/": {
      "filePath": "u/$localId/_staff.staff/orders/index.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/settings/": {
      "filePath": "u/$localId/_staff.staff/settings/index.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/tds-merchants/": {
      "filePath": "u/$localId/_staff.staff/tds-merchants/index.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/transactions/": {
      "filePath": "u/$localId/_staff.staff/transactions/index.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/users/": {
      "filePath": "u/$localId/_staff.staff/users/index.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_acquirer/acquirer/agreements/$id/api-response": {
      "filePath": "u/$localId/_acquirer.acquirer/agreements/$id/api-response.tsx",
      "parent": "/u/$localId/_acquirer/acquirer/agreements/$id"
    },
    "/u/$localId/_acquirer/acquirer/agreements/$id/orders": {
      "filePath": "u/$localId/_acquirer.acquirer/agreements/$id/orders.tsx",
      "parent": "/u/$localId/_acquirer/acquirer/agreements/$id"
    },
    "/u/$localId/_acquirer/acquirer/api-keys/$id/edit": {
      "filePath": "u/$localId/_acquirer.acquirer/api-keys/$id/edit.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_acquirer/acquirer/card-authentications/$id/apiResponse": {
      "filePath": "u/$localId/_acquirer.acquirer/card-authentications/$id/apiResponse.tsx",
      "parent": "/u/$localId/_acquirer/acquirer/card-authentications/$id"
    },
    "/u/$localId/_acquirer/acquirer/card-authentications/$id/auth": {
      "filePath": "u/$localId/_acquirer.acquirer/card-authentications/$id/auth.tsx",
      "parent": "/u/$localId/_acquirer/acquirer/card-authentications/$id"
    },
    "/u/$localId/_acquirer/acquirer/card-authentications/$id/merchant": {
      "filePath": "u/$localId/_acquirer.acquirer/card-authentications/$id/merchant.tsx",
      "parent": "/u/$localId/_acquirer/acquirer/card-authentications/$id"
    },
    "/u/$localId/_acquirer/acquirer/merchants/$merchantId/card-authentications": {
      "filePath": "u/$localId/_acquirer.acquirer/merchants/$merchantId/card-authentications.tsx",
      "parent": "/u/$localId/_acquirer/acquirer/merchants/$merchantId"
    },
    "/u/$localId/_acquirer/acquirer/merchants/$merchantId/links": {
      "filePath": "u/$localId/_acquirer.acquirer/merchants/$merchantId/links.tsx",
      "parent": "/u/$localId/_acquirer/acquirer/merchants/$merchantId"
    },
    "/u/$localId/_acquirer/acquirer/merchants/$merchantId/orders": {
      "filePath": "u/$localId/_acquirer.acquirer/merchants/$merchantId/orders.tsx",
      "parent": "/u/$localId/_acquirer/acquirer/merchants/$merchantId"
    },
    "/u/$localId/_acquirer/acquirer/merchants/$merchantId/transactions": {
      "filePath": "u/$localId/_acquirer.acquirer/merchants/$merchantId/transactions.tsx",
      "parent": "/u/$localId/_acquirer/acquirer/merchants/$merchantId"
    },
    "/u/$localId/_acquirer/acquirer/merchants/$merchantId/users": {
      "filePath": "u/$localId/_acquirer.acquirer/merchants/$merchantId/users.tsx",
      "parent": "/u/$localId/_acquirer/acquirer/merchants/$merchantId"
    },
    "/u/$localId/_acquirer/acquirer/merchants/$merchantId/edit": {
      "filePath": "u/$localId/_acquirer.acquirer/merchants/$merchantId_/edit.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_acquirer/acquirer/orders/$id/agreement": {
      "filePath": "u/$localId/_acquirer.acquirer/orders/$id/agreement.tsx",
      "parent": "/u/$localId/_acquirer/acquirer/orders/$id"
    },
    "/u/$localId/_acquirer/acquirer/orders/$id/apiResponse": {
      "filePath": "u/$localId/_acquirer.acquirer/orders/$id/apiResponse.tsx",
      "parent": "/u/$localId/_acquirer/acquirer/orders/$id"
    },
    "/u/$localId/_acquirer/acquirer/orders/$id/merchant": {
      "filePath": "u/$localId/_acquirer.acquirer/orders/$id/merchant.tsx",
      "parent": "/u/$localId/_acquirer/acquirer/orders/$id"
    },
    "/u/$localId/_acquirer/acquirer/orders/$id/source": {
      "filePath": "u/$localId/_acquirer.acquirer/orders/$id/source.tsx",
      "parent": "/u/$localId/_acquirer/acquirer/orders/$id"
    },
    "/u/$localId/_acquirer/acquirer/orders/$id/subMerchant": {
      "filePath": "u/$localId/_acquirer.acquirer/orders/$id/subMerchant.tsx",
      "parent": "/u/$localId/_acquirer/acquirer/orders/$id"
    },
    "/u/$localId/_acquirer/acquirer/orders/$id/transactions": {
      "filePath": "u/$localId/_acquirer.acquirer/orders/$id/transactions.tsx",
      "parent": "/u/$localId/_acquirer/acquirer/orders/$id"
    },
    "/u/$localId/_acquirer/acquirer/payment-controls/$type/$id": {
      "filePath": "u/$localId/_acquirer.acquirer/payment-controls/$type/$id.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_acquirer/acquirer/users/$id/edit": {
      "filePath": "u/$localId/_acquirer.acquirer/users/$id/edit.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_merchant/merchant/agreements/$id/api-response": {
      "filePath": "u/$localId/_merchant.merchant/agreements/$id/api-response.tsx",
      "parent": "/u/$localId/_merchant/merchant/agreements/$id"
    },
    "/u/$localId/_merchant/merchant/agreements/$id/orders": {
      "filePath": "u/$localId/_merchant.merchant/agreements/$id/orders.tsx",
      "parent": "/u/$localId/_merchant/merchant/agreements/$id"
    },
    "/u/$localId/_merchant/merchant/api-keys/$id/edit": {
      "filePath": "u/$localId/_merchant.merchant/api-keys/$id/edit.tsx",
      "parent": "/u/$localId/_merchant"
    },
    "/u/$localId/_merchant/merchant/card-authentications/$id/apiResponse": {
      "filePath": "u/$localId/_merchant.merchant/card-authentications/$id/apiResponse.tsx",
      "parent": "/u/$localId/_merchant/merchant/card-authentications/$id"
    },
    "/u/$localId/_merchant/merchant/card-authentications/$id/auth": {
      "filePath": "u/$localId/_merchant.merchant/card-authentications/$id/auth.tsx",
      "parent": "/u/$localId/_merchant/merchant/card-authentications/$id"
    },
    "/u/$localId/_merchant/merchant/card-authentications/$id/merchant": {
      "filePath": "u/$localId/_merchant.merchant/card-authentications/$id/merchant.tsx",
      "parent": "/u/$localId/_merchant/merchant/card-authentications/$id"
    },
    "/u/$localId/_merchant/merchant/orders/$id/agreement": {
      "filePath": "u/$localId/_merchant.merchant/orders/$id/agreement.tsx",
      "parent": "/u/$localId/_merchant/merchant/orders/$id"
    },
    "/u/$localId/_merchant/merchant/orders/$id/apiResponse": {
      "filePath": "u/$localId/_merchant.merchant/orders/$id/apiResponse.tsx",
      "parent": "/u/$localId/_merchant/merchant/orders/$id"
    },
    "/u/$localId/_merchant/merchant/orders/$id/merchant": {
      "filePath": "u/$localId/_merchant.merchant/orders/$id/merchant.tsx",
      "parent": "/u/$localId/_merchant/merchant/orders/$id"
    },
    "/u/$localId/_merchant/merchant/orders/$id/source": {
      "filePath": "u/$localId/_merchant.merchant/orders/$id/source.tsx",
      "parent": "/u/$localId/_merchant/merchant/orders/$id"
    },
    "/u/$localId/_merchant/merchant/orders/$id/subMerchant": {
      "filePath": "u/$localId/_merchant.merchant/orders/$id/subMerchant.tsx",
      "parent": "/u/$localId/_merchant/merchant/orders/$id"
    },
    "/u/$localId/_merchant/merchant/orders/$id/transactions": {
      "filePath": "u/$localId/_merchant.merchant/orders/$id/transactions.tsx",
      "parent": "/u/$localId/_merchant/merchant/orders/$id"
    },
    "/u/$localId/_merchant/merchant/payment-controls/$type/$id": {
      "filePath": "u/$localId/_merchant.merchant/payment-controls/$type/$id.tsx",
      "parent": "/u/$localId/_merchant"
    },
    "/u/$localId/_merchant/merchant/users/$id/edit": {
      "filePath": "u/$localId/_merchant.merchant/users/$id/edit.tsx",
      "parent": "/u/$localId/_merchant"
    },
    "/u/$localId/_staff/staff/acquirers/$acquirerId/api-keys": {
      "filePath": "u/$localId/_staff.staff/acquirers/$acquirerId/api-keys.tsx",
      "parent": "/u/$localId/_staff/staff/acquirers/$acquirerId"
    },
    "/u/$localId/_staff/staff/acquirers/$acquirerId/links": {
      "filePath": "u/$localId/_staff.staff/acquirers/$acquirerId/links.tsx",
      "parent": "/u/$localId/_staff/staff/acquirers/$acquirerId"
    },
    "/u/$localId/_staff/staff/acquirers/$acquirerId/merchants": {
      "filePath": "u/$localId/_staff.staff/acquirers/$acquirerId/merchants.tsx",
      "parent": "/u/$localId/_staff/staff/acquirers/$acquirerId"
    },
    "/u/$localId/_staff/staff/acquirers/$acquirerId/orders": {
      "filePath": "u/$localId/_staff.staff/acquirers/$acquirerId/orders.tsx",
      "parent": "/u/$localId/_staff/staff/acquirers/$acquirerId"
    },
    "/u/$localId/_staff/staff/acquirers/$acquirerId/transactions": {
      "filePath": "u/$localId/_staff.staff/acquirers/$acquirerId/transactions.tsx",
      "parent": "/u/$localId/_staff/staff/acquirers/$acquirerId"
    },
    "/u/$localId/_staff/staff/acquirers/$acquirerId/users": {
      "filePath": "u/$localId/_staff.staff/acquirers/$acquirerId/users.tsx",
      "parent": "/u/$localId/_staff/staff/acquirers/$acquirerId"
    },
    "/u/$localId/_staff/staff/acquirers/$acquirerId/edit": {
      "filePath": "u/$localId/_staff.staff/acquirers/$acquirerId_/edit.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/agreements/$id/api-response": {
      "filePath": "u/$localId/_staff.staff/agreements/$id/api-response.tsx",
      "parent": "/u/$localId/_staff/staff/agreements/$id"
    },
    "/u/$localId/_staff/staff/agreements/$id/orders": {
      "filePath": "u/$localId/_staff.staff/agreements/$id/orders.tsx",
      "parent": "/u/$localId/_staff/staff/agreements/$id"
    },
    "/u/$localId/_staff/staff/bench-users/$id/edit": {
      "filePath": "u/$localId/_staff.staff/bench-users/$id/edit.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/card-authentications/$id/apiResponse": {
      "filePath": "u/$localId/_staff.staff/card-authentications/$id/apiResponse.tsx",
      "parent": "/u/$localId/_staff/staff/card-authentications/$id"
    },
    "/u/$localId/_staff/staff/card-authentications/$id/auth": {
      "filePath": "u/$localId/_staff.staff/card-authentications/$id/auth.tsx",
      "parent": "/u/$localId/_staff/staff/card-authentications/$id"
    },
    "/u/$localId/_staff/staff/card-authentications/$id/merchant": {
      "filePath": "u/$localId/_staff.staff/card-authentications/$id/merchant.tsx",
      "parent": "/u/$localId/_staff/staff/card-authentications/$id"
    },
    "/u/$localId/_staff/staff/merchants/$merchantId/api-keys": {
      "filePath": "u/$localId/_staff.staff/merchants/$merchantId/api-keys.tsx",
      "parent": "/u/$localId/_staff/staff/merchants/$merchantId"
    },
    "/u/$localId/_staff/staff/merchants/$merchantId/links": {
      "filePath": "u/$localId/_staff.staff/merchants/$merchantId/links.tsx",
      "parent": "/u/$localId/_staff/staff/merchants/$merchantId"
    },
    "/u/$localId/_staff/staff/merchants/$merchantId/orders": {
      "filePath": "u/$localId/_staff.staff/merchants/$merchantId/orders.tsx",
      "parent": "/u/$localId/_staff/staff/merchants/$merchantId"
    },
    "/u/$localId/_staff/staff/merchants/$merchantId/transactions": {
      "filePath": "u/$localId/_staff.staff/merchants/$merchantId/transactions.tsx",
      "parent": "/u/$localId/_staff/staff/merchants/$merchantId"
    },
    "/u/$localId/_staff/staff/merchants/$merchantId/users": {
      "filePath": "u/$localId/_staff.staff/merchants/$merchantId/users.tsx",
      "parent": "/u/$localId/_staff/staff/merchants/$merchantId"
    },
    "/u/$localId/_staff/staff/merchants/$merchantId/edit": {
      "filePath": "u/$localId/_staff.staff/merchants/$merchantId_/edit.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/orders/$id/agreement": {
      "filePath": "u/$localId/_staff.staff/orders/$id/agreement.tsx",
      "parent": "/u/$localId/_staff/staff/orders/$id"
    },
    "/u/$localId/_staff/staff/orders/$id/apiResponse": {
      "filePath": "u/$localId/_staff.staff/orders/$id/apiResponse.tsx",
      "parent": "/u/$localId/_staff/staff/orders/$id"
    },
    "/u/$localId/_staff/staff/orders/$id/merchant": {
      "filePath": "u/$localId/_staff.staff/orders/$id/merchant.tsx",
      "parent": "/u/$localId/_staff/staff/orders/$id"
    },
    "/u/$localId/_staff/staff/orders/$id/source": {
      "filePath": "u/$localId/_staff.staff/orders/$id/source.tsx",
      "parent": "/u/$localId/_staff/staff/orders/$id"
    },
    "/u/$localId/_staff/staff/orders/$id/subMerchant": {
      "filePath": "u/$localId/_staff.staff/orders/$id/subMerchant.tsx",
      "parent": "/u/$localId/_staff/staff/orders/$id"
    },
    "/u/$localId/_staff/staff/orders/$id/transactions": {
      "filePath": "u/$localId/_staff.staff/orders/$id/transactions.tsx",
      "parent": "/u/$localId/_staff/staff/orders/$id"
    },
    "/u/$localId/_staff/staff/users/$id/edit": {
      "filePath": "u/$localId/_staff.staff/users/$id/edit.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_acquirer/acquirer/api-keys/$id/": {
      "filePath": "u/$localId/_acquirer.acquirer/api-keys/$id/index.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_acquirer/acquirer/payment-controls/$type/": {
      "filePath": "u/$localId/_acquirer.acquirer/payment-controls/$type/index.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_acquirer/acquirer/users/$id/": {
      "filePath": "u/$localId/_acquirer.acquirer/users/$id/index.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_merchant/merchant/api-keys/$id/": {
      "filePath": "u/$localId/_merchant.merchant/api-keys/$id/index.tsx",
      "parent": "/u/$localId/_merchant"
    },
    "/u/$localId/_merchant/merchant/payment-controls/$type/": {
      "filePath": "u/$localId/_merchant.merchant/payment-controls/$type/index.tsx",
      "parent": "/u/$localId/_merchant"
    },
    "/u/$localId/_merchant/merchant/users/$id/": {
      "filePath": "u/$localId/_merchant.merchant/users/$id/index.tsx",
      "parent": "/u/$localId/_merchant"
    },
    "/u/$localId/_staff/staff/users/$id/": {
      "filePath": "u/$localId/_staff.staff/users/$id/index.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_acquirer/acquirer/merchants/$merchantId/links/new": {
      "filePath": "u/$localId/_acquirer.acquirer/merchants/$merchantId_/links_/new.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_acquirer/acquirer/merchants/$merchantId/users/new": {
      "filePath": "u/$localId/_acquirer.acquirer/merchants/$merchantId_/users_/new.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_staff/staff/acquirers/$acquirerId/api-keys/new": {
      "filePath": "u/$localId/_staff.staff/acquirers/$acquirerId_/api-keys_/new.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/acquirers/$acquirerId/links/new": {
      "filePath": "u/$localId/_staff.staff/acquirers/$acquirerId_/links_/new.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/acquirers/$acquirerId/merchants/new": {
      "filePath": "u/$localId/_staff.staff/acquirers/$acquirerId_/merchants_/new.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/acquirers/$acquirerId/users/new": {
      "filePath": "u/$localId/_staff.staff/acquirers/$acquirerId_/users_/new.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/merchants/$merchantId/api-keys/new": {
      "filePath": "u/$localId/_staff.staff/merchants/$merchantId_/api-keys_/new.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/merchants/$merchantId/links/new": {
      "filePath": "u/$localId/_staff.staff/merchants/$merchantId_/links_/new.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/merchants/$merchantId/users/new": {
      "filePath": "u/$localId/_staff.staff/merchants/$merchantId_/users_/new.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_acquirer/acquirer/merchants/$merchantId/payment-controls/": {
      "filePath": "u/$localId/_acquirer.acquirer/merchants/$merchantId/payment-controls/index.tsx",
      "parent": "/u/$localId/_acquirer/acquirer/merchants/$merchantId"
    },
    "/u/$localId/_staff/staff/acquirers/$acquirerId/payment-controls/": {
      "filePath": "u/$localId/_staff.staff/acquirers/$acquirerId/payment-controls/index.tsx",
      "parent": "/u/$localId/_staff/staff/acquirers/$acquirerId"
    },
    "/u/$localId/_staff/staff/merchants/$merchantId/payment-controls/": {
      "filePath": "u/$localId/_staff.staff/merchants/$merchantId/payment-controls/index.tsx",
      "parent": "/u/$localId/_staff/staff/merchants/$merchantId"
    },
    "/u/$localId/_acquirer/acquirer/merchants/$merchantId/links/$id/edit": {
      "filePath": "u/$localId/_acquirer.acquirer/merchants/$merchantId_/links_/$id.edit.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_acquirer/acquirer/merchants/$merchantId/payment-controls/$type/$id": {
      "filePath": "u/$localId/_acquirer.acquirer/merchants/$merchantId_/payment-controls_/$type/$id.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_acquirer/acquirer/merchants/$merchantId/users/$id/edit": {
      "filePath": "u/$localId/_acquirer.acquirer/merchants/$merchantId_/users_/$id.edit.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_staff/staff/acquirers/$acquirerId/api-keys/$id/edit": {
      "filePath": "u/$localId/_staff.staff/acquirers/$acquirerId_/api-keys_/$id.edit.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/acquirers/$acquirerId/links/$id/edit": {
      "filePath": "u/$localId/_staff.staff/acquirers/$acquirerId_/links_/$id.edit.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/acquirers/$acquirerId/payment-controls/$type/$id": {
      "filePath": "u/$localId/_staff.staff/acquirers/$acquirerId_/payment-controls_/$type/$id.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/acquirers/$acquirerId/users/$id/edit": {
      "filePath": "u/$localId/_staff.staff/acquirers/$acquirerId_/users_/$id.edit.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/merchants/$merchantId/api-keys/$id/edit": {
      "filePath": "u/$localId/_staff.staff/merchants/$merchantId_/api-keys_/$id.edit.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/merchants/$merchantId/links/$id/edit": {
      "filePath": "u/$localId/_staff.staff/merchants/$merchantId_/links_/$id.edit.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/merchants/$merchantId/payment-controls/$type/$id": {
      "filePath": "u/$localId/_staff.staff/merchants/$merchantId_/payment-controls_/$type/$id.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/merchants/$merchantId/users/$id/edit": {
      "filePath": "u/$localId/_staff.staff/merchants/$merchantId_/users_/$id.edit.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_acquirer/acquirer/merchants/$merchantId/payment-controls/$type/": {
      "filePath": "u/$localId/_acquirer.acquirer/merchants/$merchantId/payment-controls/$type/index.tsx",
      "parent": "/u/$localId/_acquirer/acquirer/merchants/$merchantId"
    },
    "/u/$localId/_acquirer/acquirer/merchants/$merchantId/links/$id/": {
      "filePath": "u/$localId/_acquirer.acquirer/merchants/$merchantId_/links_/$id.index.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_acquirer/acquirer/merchants/$merchantId/users/$id/": {
      "filePath": "u/$localId/_acquirer.acquirer/merchants/$merchantId_/users_/$id.index.tsx",
      "parent": "/u/$localId/_acquirer"
    },
    "/u/$localId/_staff/staff/acquirers/$acquirerId/payment-controls/$type/": {
      "filePath": "u/$localId/_staff.staff/acquirers/$acquirerId/payment-controls/$type/index.tsx",
      "parent": "/u/$localId/_staff/staff/acquirers/$acquirerId"
    },
    "/u/$localId/_staff/staff/acquirers/$acquirerId/api-keys/$id/": {
      "filePath": "u/$localId/_staff.staff/acquirers/$acquirerId_/api-keys_/$id.index.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/acquirers/$acquirerId/links/$id/": {
      "filePath": "u/$localId/_staff.staff/acquirers/$acquirerId_/links_/$id.index.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/acquirers/$acquirerId/users/$id/": {
      "filePath": "u/$localId/_staff.staff/acquirers/$acquirerId_/users_/$id.index.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/merchants/$merchantId/payment-controls/$type/": {
      "filePath": "u/$localId/_staff.staff/merchants/$merchantId/payment-controls/$type/index.tsx",
      "parent": "/u/$localId/_staff/staff/merchants/$merchantId"
    },
    "/u/$localId/_staff/staff/merchants/$merchantId/api-keys/$id/": {
      "filePath": "u/$localId/_staff.staff/merchants/$merchantId_/api-keys_/$id.index.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/merchants/$merchantId/links/$id/": {
      "filePath": "u/$localId/_staff.staff/merchants/$merchantId_/links_/$id.index.tsx",
      "parent": "/u/$localId/_staff"
    },
    "/u/$localId/_staff/staff/merchants/$merchantId/users/$id/": {
      "filePath": "u/$localId/_staff.staff/merchants/$merchantId_/users_/$id.index.tsx",
      "parent": "/u/$localId/_staff"
    }
  }
}
ROUTE_MANIFEST_END */
